var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg4AxSingleTandem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1855.77 800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fbb040;}.cls-1,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9,.cls-10,.cls-11,.cls-12,.cls-13,.cls-14,.cls-15,.cls-16,.cls-17,.cls-18,.cls-19,.cls-20,.cls-21,.cls-22,.cls-23,.cls-24,.cls-25,.cls-26,.cls-27,.cls-28,.cls-29,.cls-30,.cls-31,.cls-32,.cls-33,.cls-34,.cls-35,.cls-36,.cls-37,.cls-38,.cls-39,.cls-40,.cls-41,.cls-42,.cls-43,.cls-44,.cls-45,.cls-46,.cls-47,.cls-48,.cls-49,.cls-50,.cls-51,.cls-52,.cls-53,.cls-54,.cls-55,.cls-56,.cls-57,.cls-58,.cls-59,.cls-60,.cls-61,.cls-62,.cls-63,.cls-64,.cls-65,.cls-66,.cls-67,.cls-68,.cls-69,.cls-70,.cls-71,.cls-72,.cls-73,.cls-74,.cls-75,.cls-76,.cls-77,.cls-78,.cls-79,.cls-80,.cls-81,.cls-82,.cls-83,.cls-84,.cls-85,.cls-86,.cls-87,.cls-88,.cls-89,.cls-90,.cls-91,.cls-92,.cls-93,.cls-94,.cls-95,.cls-96,.cls-97,.cls-98,.cls-99,.cls-100,.cls-101,.cls-102,.cls-103,.cls-104,.cls-105,.cls-106,.cls-107,.cls-108,.cls-109,.cls-110,.cls-111,.cls-112,.cls-113,.cls-114,.cls-115,.cls-116,.cls-117,.cls-118,.cls-119,.cls-120,.cls-121,.cls-122,.cls-123,.cls-124,.cls-125,.cls-126,.cls-127,.cls-128,.cls-129,.cls-130,.cls-131,.cls-132,.cls-133,.cls-134,.cls-135,.cls-136,.cls-137,.cls-138,.cls-139,.cls-140,.cls-141,.cls-142,.cls-143,.cls-144,.cls-145,.cls-146,.cls-147,.cls-148,.cls-149,.cls-150,.cls-151,.cls-152,.cls-153,.cls-154,.cls-155,.cls-156,.cls-157,.cls-158,.cls-159,.cls-160,.cls-161,.cls-162,.cls-163,.cls-164,.cls-165,.cls-166,.cls-167{stroke-width:0px;}.cls-2{fill:url(#New_Gradient_Swatch_4);}.cls-3{fill:url(#New_Gradient_Swatch_5);}.cls-4{fill:url(#New_Gradient_Swatch_3);}.cls-5{fill:url(#linear-gradient-84);}.cls-5,.cls-45,.cls-168,.cls-144,.cls-148,.cls-149,.cls-151,.cls-152,.cls-162,.cls-164,.cls-166{mix-blend-mode:multiply;}.cls-6{fill:url(#New_Gradient_Swatch_3-3);}.cls-7{fill:url(#New_Gradient_Swatch_3-4);}.cls-8{fill:url(#New_Gradient_Swatch_3-2);}.cls-9{fill:url(#New_Gradient_Swatch_4-3);}.cls-10{fill:url(#New_Gradient_Swatch_4-2);}.cls-11{fill:url(#New_Gradient_Swatch_4-4);}.cls-12{fill:url(#linear-gradient-120);}.cls-13{fill:url(#linear-gradient-125);}.cls-14{fill:url(#linear-gradient-124);}.cls-15{fill:url(#linear-gradient-126);}.cls-16{fill:url(#linear-gradient-131);}.cls-17{fill:url(#linear-gradient-132);}.cls-18{fill:url(#linear-gradient-130);}.cls-19{fill:url(#linear-gradient-133);}.cls-20{fill:url(#linear-gradient-100);}.cls-21{fill:url(#linear-gradient-101);}.cls-22{fill:url(#linear-gradient-123);}.cls-23{fill:url(#linear-gradient-129);}.cls-24{fill:url(#linear-gradient-122);}.cls-25{fill:url(#linear-gradient-109);}.cls-26{fill:url(#linear-gradient-108);}.cls-27{fill:url(#linear-gradient-106);}.cls-28{fill:url(#linear-gradient-107);}.cls-29{fill:url(#linear-gradient-102);}.cls-30{fill:url(#linear-gradient-104);}.cls-31{fill:url(#linear-gradient-103);}.cls-32{fill:url(#linear-gradient-105);}.cls-33{fill:url(#linear-gradient-117);}.cls-34{fill:url(#linear-gradient-118);}.cls-35{fill:url(#linear-gradient-111);}.cls-36{fill:url(#linear-gradient-112);}.cls-37{fill:url(#linear-gradient-127);}.cls-38{fill:url(#linear-gradient-128);}.cls-39{fill:url(#linear-gradient-110);}.cls-40{fill:url(#linear-gradient-113);}.cls-41{fill:url(#linear-gradient-114);}.cls-42{fill:url(#linear-gradient-115);}.cls-43{fill:url(#linear-gradient-116);}.cls-44{fill:url(#linear-gradient-119);}.cls-169{mask:url(#mask);}.cls-45{fill:#fff;}.cls-46{fill:url(#linear-gradient);}.cls-170{filter:url(#luminosity-noclip);}.cls-47{fill:#ef4136;}.cls-48,.cls-148{fill:#6d6e71;}.cls-49{fill:#f15a29;}.cls-50{fill:url(#linear-gradient-38);}.cls-51{fill:url(#linear-gradient-33);}.cls-52{fill:url(#linear-gradient-29);}.cls-53{fill:url(#linear-gradient-32);}.cls-54{fill:url(#linear-gradient-30);}.cls-55{fill:url(#linear-gradient-31);}.cls-56{fill:url(#linear-gradient-36);}.cls-57{fill:url(#linear-gradient-39);}.cls-58{fill:url(#linear-gradient-34);}.cls-59{fill:url(#linear-gradient-37);}.cls-60{fill:url(#linear-gradient-35);}.cls-61{fill:url(#linear-gradient-28);}.cls-62{fill:url(#linear-gradient-25);}.cls-63{fill:url(#linear-gradient-11);}.cls-64{fill:url(#linear-gradient-12);}.cls-65{fill:url(#linear-gradient-13);}.cls-66{fill:url(#linear-gradient-10);}.cls-67{fill:url(#linear-gradient-17);}.cls-68{fill:url(#linear-gradient-16);}.cls-69{fill:url(#linear-gradient-19);}.cls-70{fill:url(#linear-gradient-15);}.cls-71{fill:url(#linear-gradient-23);}.cls-72{fill:url(#linear-gradient-21);}.cls-73{fill:url(#linear-gradient-18);}.cls-74{fill:url(#linear-gradient-14);}.cls-75{fill:url(#linear-gradient-22);}.cls-76{fill:url(#linear-gradient-20);}.cls-77{fill:url(#linear-gradient-27);}.cls-78{fill:url(#linear-gradient-24);}.cls-79{fill:url(#linear-gradient-26);}.cls-80{fill:url(#linear-gradient-45);}.cls-81{fill:url(#linear-gradient-46);}.cls-82{fill:url(#linear-gradient-44);}.cls-83{fill:url(#linear-gradient-48);}.cls-84{fill:url(#linear-gradient-49);}.cls-85{fill:url(#linear-gradient-47);}.cls-86{fill:url(#linear-gradient-42);}.cls-87{fill:url(#linear-gradient-43);}.cls-88{fill:url(#linear-gradient-40);}.cls-89{fill:url(#linear-gradient-41);}.cls-90{fill:url(#linear-gradient-59);}.cls-91{fill:url(#linear-gradient-57);}.cls-92{fill:url(#linear-gradient-58);}.cls-93{fill:url(#linear-gradient-55);}.cls-94{fill:url(#linear-gradient-56);}.cls-95{fill:url(#linear-gradient-53);}.cls-96{fill:url(#linear-gradient-51);}.cls-97{fill:url(#linear-gradient-52);}.cls-98{fill:url(#linear-gradient-50);}.cls-99{fill:url(#linear-gradient-54);}.cls-100{fill:url(#linear-gradient-60);}.cls-101{fill:url(#linear-gradient-61);}.cls-102{fill:url(#linear-gradient-62);}.cls-103{fill:url(#linear-gradient-65);}.cls-104{fill:url(#linear-gradient-79);}.cls-105{fill:url(#linear-gradient-78);}.cls-106{fill:url(#linear-gradient-77);}.cls-107{fill:url(#linear-gradient-75);}.cls-108{fill:url(#linear-gradient-76);}.cls-109{fill:url(#linear-gradient-74);}.cls-110{fill:url(#linear-gradient-67);}.cls-111{fill:url(#linear-gradient-68);}.cls-112{fill:url(#linear-gradient-66);}.cls-113{fill:url(#linear-gradient-63);}.cls-114{fill:url(#linear-gradient-69);}.cls-115{fill:url(#linear-gradient-64);}.cls-116{fill:url(#linear-gradient-71);}.cls-117{fill:url(#linear-gradient-72);}.cls-118{fill:url(#linear-gradient-70);}.cls-119{fill:url(#linear-gradient-73);}.cls-120{fill:url(#linear-gradient-85);}.cls-121{fill:url(#linear-gradient-82);}.cls-122{fill:url(#linear-gradient-83);}.cls-123{fill:url(#linear-gradient-89);}.cls-124{fill:url(#linear-gradient-88);}.cls-125{fill:url(#linear-gradient-86);}.cls-126{fill:url(#linear-gradient-87);}.cls-127{fill:url(#linear-gradient-80);}.cls-128{fill:url(#linear-gradient-81);}.cls-129{fill:url(#linear-gradient-98);}.cls-130{fill:url(#linear-gradient-91);}.cls-131{fill:url(#linear-gradient-92);}.cls-132{fill:url(#linear-gradient-93);}.cls-133{fill:url(#linear-gradient-90);}.cls-134{fill:url(#linear-gradient-96);}.cls-135{fill:url(#linear-gradient-97);}.cls-136{fill:url(#linear-gradient-94);}.cls-137{fill:url(#linear-gradient-95);}.cls-138{fill:url(#linear-gradient-99);}.cls-139{fill:#3c2415;}.cls-140{fill:#f1f2f2;}.cls-141{fill:#58595b;}.cls-142,.cls-149{fill:#bcbec0;}.cls-143{fill:#808285;}.cls-144{fill:#8dc63f;}.cls-145,.cls-153{fill:#000;}.cls-146,.cls-151{fill:#a7a9ac;}.cls-147{fill:url(#New_Gradient_Swatch_11_cop);}.cls-150{fill:#be1e2d;}.cls-152,.cls-163{fill:#e6e7e8;}.cls-153{opacity:.5;}.cls-154{fill:url(#linear-gradient-4);}.cls-155{fill:url(#linear-gradient-2);}.cls-156{fill:url(#linear-gradient-3);}.cls-157{fill:url(#linear-gradient-8);}.cls-158{fill:url(#linear-gradient-9);}.cls-159{fill:url(#linear-gradient-7);}.cls-160{fill:url(#linear-gradient-5);}.cls-161{fill:url(#linear-gradient-6);}.cls-162{fill:url(#linear-gradient-121);}.cls-171{isolation:isolate;}.cls-164{fill:#414042;}.cls-165{fill:#d1d3d4;}.cls-166{fill:#939598;}.cls-167{fill:#231f20;}"), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip",
    x: 0,
    y: 712.69,
    width: 1855.77,
    height: 87.31,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 0,
    y: 712.69,
    width: 1855.77,
    height: 87.31,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-170"
  }, /*#__PURE__*/React.createElement("image", {
    width: 1857,
    height: 88,
    transform: "translate(-.93 712.59)",
    xlinkHref: "data:image/png;base64,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"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1090.42,
    y1: 533.44,
    x2: 1090.42,
    y2: 514.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#231f20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_5",
    x1: 868.57,
    y1: 572.07,
    x2: 868.57,
    y2: 604.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#603913"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 4578.17,
    y1: 6881.27,
    x2: 4578.17,
    y2: 6702.58,
    gradientTransform: "translate(-5090.07 5184.13) rotate(-90)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#231f20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#262224"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#525254"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#58595b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#515254"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#403f41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#252122"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#231f20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 4599.65,
    y1: 6699.6,
    x2: 4599.65,
    y2: 6884.07,
    gradientTransform: "translate(6393.03 7467.92) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#231f20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#2b2729"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#3b393b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#3a393b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#2a2728"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#231f20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    y1: 6699.6,
    y2: 6884.07,
    gradientTransform: "translate(6390.45 7465.35) rotate(-180)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    y1: 6699.61,
    y2: 6884.07,
    gradientTransform: "translate(6387.27 7462.17) rotate(-180)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    y1: 6699.6,
    y2: 6884.07,
    gradientTransform: "translate(6383.45 7458.34) rotate(-180)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    y1: 6699.6,
    y2: 6884.07,
    gradientTransform: "translate(6378.95 7453.84) rotate(-180)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    y1: 6699.6,
    y2: 6884.07,
    gradientTransform: "translate(6373.91 7448.8) rotate(-180)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    y1: 6699.6,
    y2: 6884.07,
    gradientTransform: "translate(6368.32 7443.21) rotate(-180)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    y1: 6699.6,
    y2: 6884.07,
    gradientTransform: "translate(6362.27 7437.16) rotate(-180)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    y1: 6699.6,
    y2: 6884.07,
    gradientTransform: "translate(6355.6 7430.49) rotate(-180)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    y1: 6699.6,
    y2: 6884.07,
    gradientTransform: "translate(6348.67 7423.56) rotate(-180)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    y1: 6699.6,
    y2: 6884.07,
    gradientTransform: "translate(6341.24 7416.13) rotate(-180)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    y1: 6699.6,
    y2: 6884.07,
    gradientTransform: "translate(6333.58 7408.48) rotate(-180)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    y1: 6699.6,
    y2: 6884.07,
    gradientTransform: "translate(6325.57 7400.46) rotate(-180)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    y1: 6699.6,
    y2: 6884.07,
    gradientTransform: "translate(6317.45 7392.34) rotate(-180)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    y1: 6699.6,
    y2: 6884.07,
    gradientTransform: "translate(6309.23 7384.12) rotate(-180)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    y1: 6699.6,
    y2: 6884.07,
    gradientTransform: "translate(-2989.56 -6115.68)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    y1: 6699.6,
    y2: 6884.07,
    gradientTransform: "translate(-2986.99 -6118.26)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    y1: 6699.6,
    y2: 6884.07,
    gradientTransform: "translate(-2983.81 -6121.44)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    y1: 6699.6,
    y2: 6884.07,
    gradientTransform: "translate(-2979.98 -6125.27)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    y1: 6699.6,
    y2: 6884.07,
    gradientTransform: "translate(-2975.48 -6129.77)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    y1: 6699.6,
    y2: 6884.07,
    gradientTransform: "translate(-2970.44 -6134.81)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    y1: 6699.6,
    y2: 6884.07,
    gradientTransform: "translate(-2964.86 -6140.39)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    y1: 6699.6,
    y2: 6884.07,
    gradientTransform: "translate(-2958.81 -6146.44)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    y1: 6699.6,
    y2: 6884.07,
    gradientTransform: "translate(-2952.13 -6153.11)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    y1: 6699.6,
    y2: 6884.07,
    gradientTransform: "translate(-2945.21 -6160.04)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    y1: 6699.6,
    y2: 6884.07,
    gradientTransform: "translate(-2937.77 -6167.47)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    y1: 6699.6,
    y2: 6884.07,
    gradientTransform: "translate(-2930.12 -6175.13)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    y1: 6699.6,
    y2: 6884.07,
    gradientTransform: "translate(-2922.1 -6183.14)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    y1: 6699.6,
    y2: 6884.07,
    gradientTransform: "translate(-2913.99 -6191.26)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    y1: 6699.6,
    y2: 6884.07,
    gradientTransform: "translate(-2905.76 -6199.48)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    y1: 6699.6,
    y2: 6884.07,
    gradientTransform: "translate(-2897.92 -6207.33)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 4556.69,
    x2: 4556.69,
    gradientTransform: "translate(6350.06 7510.89) rotate(-180)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 4556.69,
    y1: 6699.6,
    x2: 4556.69,
    y2: 6884.07,
    gradientTransform: "translate(6347.48 7508.31) rotate(-180)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 4556.69,
    y1: 6699.61,
    x2: 4556.69,
    y2: 6884.07,
    gradientTransform: "translate(6344.3 7505.13) rotate(-180)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 4556.69,
    y1: 6699.6,
    x2: 4556.69,
    y2: 6884.07,
    gradientTransform: "translate(6340.48 7501.31) rotate(-180)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 4556.69,
    y1: 6699.6,
    x2: 4556.69,
    y2: 6884.07,
    gradientTransform: "translate(6335.98 7496.81) rotate(-180)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 4556.69,
    y1: 6699.6,
    x2: 4556.69,
    y2: 6884.07,
    gradientTransform: "translate(6330.94 7491.77) rotate(-180)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 4556.69,
    y1: 6699.6,
    x2: 4556.69,
    y2: 6884.07,
    gradientTransform: "translate(6325.35 7486.18) rotate(-180)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 4556.69,
    y1: 6699.6,
    x2: 4556.69,
    y2: 6884.07,
    gradientTransform: "translate(6319.3 7480.13) rotate(-180)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 4556.69,
    y1: 6699.6,
    x2: 4556.69,
    y2: 6884.07,
    gradientTransform: "translate(6312.63 7473.46) rotate(-180)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 4556.69,
    y1: 6699.6,
    x2: 4556.69,
    y2: 6884.07,
    gradientTransform: "translate(6305.7 7466.53) rotate(-180)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: 4556.69,
    y1: 6699.6,
    x2: 4556.69,
    y2: 6884.07,
    gradientTransform: "translate(6298.27 7459.1) rotate(-180)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: 4556.69,
    y1: 6699.6,
    x2: 4556.69,
    y2: 6884.07,
    gradientTransform: "translate(6290.62 7451.45) rotate(-180)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: 4556.69,
    y1: 6699.6,
    x2: 4556.69,
    y2: 6884.07,
    gradientTransform: "translate(6282.6 7443.43) rotate(-180)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: 4556.69,
    y1: 6699.6,
    x2: 4556.69,
    y2: 6884.07,
    gradientTransform: "translate(6274.48 7435.31) rotate(-180)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: 4556.69,
    y1: 6699.6,
    x2: 4556.69,
    y2: 6884.07,
    gradientTransform: "translate(6266.26 7427.09) rotate(-180)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: 4556.69,
    y1: 6699.6,
    x2: 4556.69,
    y2: 6884.07,
    gradientTransform: "translate(-2946.6 -6072.71)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: 4556.69,
    y1: 6699.6,
    x2: 4556.69,
    y2: 6884.07,
    gradientTransform: "translate(-2944.02 -6075.29)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: 4556.69,
    y1: 6699.6,
    x2: 4556.69,
    y2: 6884.07,
    gradientTransform: "translate(-2940.84 -6078.47)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: 4556.69,
    y1: 6699.6,
    x2: 4556.69,
    y2: 6884.07,
    gradientTransform: "translate(-2937.01 -6082.3)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: 4556.69,
    y1: 6699.6,
    x2: 4556.69,
    y2: 6884.07,
    gradientTransform: "translate(-2932.51 -6086.8)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: 4556.69,
    y1: 6699.6,
    x2: 4556.69,
    y2: 6884.07,
    gradientTransform: "translate(-2927.47 -6091.84)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: 4556.69,
    y1: 6699.6,
    x2: 4556.69,
    y2: 6884.07,
    gradientTransform: "translate(-2921.89 -6097.42)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: 4556.69,
    y1: 6699.6,
    x2: 4556.69,
    y2: 6884.07,
    gradientTransform: "translate(-2915.84 -6103.47)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: 4556.69,
    y1: 6699.6,
    x2: 4556.69,
    y2: 6884.07,
    gradientTransform: "translate(-2909.17 -6110.14)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: 4556.69,
    y1: 6699.6,
    x2: 4556.69,
    y2: 6884.07,
    gradientTransform: "translate(-2902.24 -6117.07)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: 4556.69,
    y1: 6699.6,
    x2: 4556.69,
    y2: 6884.07,
    gradientTransform: "translate(-2894.8 -6124.51)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    x1: 4556.69,
    y1: 6699.6,
    x2: 4556.69,
    y2: 6884.07,
    gradientTransform: "translate(-2887.15 -6132.16)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    x1: 4556.69,
    y1: 6699.6,
    x2: 4556.69,
    y2: 6884.07,
    gradientTransform: "translate(-2879.14 -6140.17)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-62",
    x1: 4556.69,
    y1: 6699.6,
    x2: 4556.69,
    y2: 6884.07,
    gradientTransform: "translate(-2871.02 -6148.29)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-63",
    x1: 4556.69,
    y1: 6699.6,
    x2: 4556.69,
    y2: 6884.07,
    gradientTransform: "translate(-2862.8 -6156.51)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-64",
    x1: 4556.69,
    y1: 6699.6,
    x2: 4556.69,
    y2: 6884.07,
    gradientTransform: "translate(-2854.95 -6164.36)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-65",
    x1: 4578.17,
    y1: 6701.1,
    x2: 4578.17,
    y2: 6884.57,
    gradientTransform: "translate(-2876.44 -6185.84)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-66",
    x1: 936.89,
    y1: 572.98,
    x2: 936.89,
    y2: 558.54,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-67",
    x1: 410.55,
    y1: 307.64,
    x2: 394.15,
    y2: 307.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#808285"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-68",
    x1: 415.35,
    y1: 565.29,
    x2: 415.35,
    y2: 483.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#1f0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#4a0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#640000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6e0001"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-69",
    x1: -934.71,
    y1: 7263.97,
    x2: -934.71,
    y2: 7182.41,
    gradientTransform: "translate(-503.06 7773.22) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#020000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#0c0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#1b0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#320000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#4e0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6e0001"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-70",
    x1: -1074.9,
    y1: 7316.94,
    x2: -1074.9,
    y2: 7384.77,
    gradientTransform: "translate(-643.25 7885.76) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6d6e71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-71",
    x1: -1074.9,
    y1: 7376.99,
    x2: -1074.9,
    y2: 7323.91,
    gradientTransform: "translate(-6969.01 1178.05) rotate(-103.28)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#938167"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-72",
    x1: -1074.9,
    y1: 7329.66,
    x2: -1074.9,
    y2: 7371.64,
    xlinkHref: "#linear-gradient-70"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-73",
    x1: -1074.9,
    y1: 7366.83,
    x2: -1074.9,
    y2: 7333.98,
    gradientTransform: "translate(-643.25 7885.76) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7d8f8a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_4",
    x1: 262.38,
    y1: 713.67,
    x2: 262.38,
    y2: 526.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#231f20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6d6e71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3",
    x1: 262.38,
    y1: 543.79,
    x2: 262.38,
    y2: 702.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58595b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-74",
    x1: 262.38,
    y1: 570.62,
    x2: 262.38,
    y2: 670.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808184"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-75",
    y1: 650.34,
    y2: 590.15,
    gradientTransform: "translate(832.84 262.12) rotate(80.78)",
    xlinkHref: "#linear-gradient-74"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-76",
    x1: 262.38,
    y1: 678.45,
    x2: 262.38,
    y2: 563.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#808285"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a7a9ac"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-77",
    x1: 262.38,
    y1: 604.09,
    x2: 262.38,
    y2: 638.57,
    gradientTransform: "translate(806 222.58) rotate(76.72)",
    xlinkHref: "#linear-gradient-70"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-78",
    x1: 262.38,
    y1: 634.15,
    x2: 262.38,
    y2: 607.3,
    gradientTransform: "translate(806 222.58) rotate(76.72)",
    xlinkHref: "#linear-gradient-70"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-79",
    x1: 906.56,
    y1: 532.98,
    x2: 906.56,
    y2: 621.86,
    gradientTransform: "translate(11.28 1153.57) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#cccecf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#bec0c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#a8aaad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#a7a9ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#919396"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#818285"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#757679"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#6e6f72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#6d6e71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-80",
    x1: 831.12,
    y1: 608.26,
    x2: 831.12,
    y2: 628.5,
    gradientTransform: "translate(162.17 1236.47) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#383739"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#212122"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-81",
    x1: 906.56,
    x2: 906.56,
    gradientTransform: "translate(11.28 1236.47) scale(1 -1)",
    xlinkHref: "#linear-gradient-80"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-82",
    x1: 982.01,
    x2: 982.01,
    gradientTransform: "translate(-139.61 1236.47) scale(1 -1)",
    xlinkHref: "#linear-gradient-80"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-83",
    x1: 934.99,
    y1: 537.21,
    x2: 954.99,
    y2: 537.21,
    gradientTransform: "translate(-65.57 1074.42) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#0b0b0b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#28292a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#58595c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#6d6e71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-84",
    x1: 157.57,
    y1: 369.71,
    x2: 157.57,
    y2: 257.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a7a9ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414042"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_4-2",
    x1: 615.89,
    x2: 615.89,
    xlinkHref: "#New_Gradient_Swatch_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-2",
    x1: 615.89,
    x2: 615.89,
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-85",
    x1: 615.89,
    x2: 615.89,
    xlinkHref: "#linear-gradient-74"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-86",
    x1: 615.89,
    y1: 650.34,
    x2: 615.89,
    y2: 590.15,
    gradientTransform: "translate(619.15 -253.76) rotate(45)",
    xlinkHref: "#linear-gradient-74"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-87",
    x1: 615.89,
    x2: 615.89,
    xlinkHref: "#linear-gradient-76"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-88",
    x1: 615.89,
    y1: 604.09,
    x2: 615.89,
    y2: 638.57,
    gradientTransform: "translate(619.15 -253.76) rotate(45)",
    xlinkHref: "#linear-gradient-70"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-89",
    x1: 615.89,
    y1: 634.15,
    x2: 615.89,
    y2: 607.3,
    gradientTransform: "translate(619.15 -253.76) rotate(45)",
    xlinkHref: "#linear-gradient-70"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-90",
    x1: 1416.36,
    y1: 546.43,
    x2: 1416.36,
    y2: 552.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#58595b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-91",
    x1: 1416.36,
    y1: 552.3,
    x2: 1416.36,
    y2: 558,
    xlinkHref: "#linear-gradient-90"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-92",
    x1: 1416.36,
    y1: 558.16,
    x2: 1416.36,
    y2: 563.61,
    xlinkHref: "#linear-gradient-90"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-93",
    x1: 1416.36,
    y1: 563.92,
    x2: 1416.36,
    y2: 569.25,
    xlinkHref: "#linear-gradient-90"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-94",
    y1: 569.35,
    y2: 575.12,
    xlinkHref: "#linear-gradient-90"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-95",
    x1: 1416.36,
    y1: 575.33,
    x2: 1416.36,
    y2: 581.32,
    xlinkHref: "#linear-gradient-90"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-96",
    x1: 1416.36,
    y1: 581.63,
    x2: 1416.36,
    y2: 586.63,
    xlinkHref: "#linear-gradient-90"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-97",
    x1: 1416.36,
    y1: 586.85,
    x2: 1416.36,
    y2: 592.06,
    xlinkHref: "#linear-gradient-90"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-98",
    x1: 1416.36,
    y1: 593.04,
    x2: 1416.36,
    y2: 598.15,
    xlinkHref: "#linear-gradient-90"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-99",
    x1: 1416.36,
    y1: 598.91,
    x2: 1416.36,
    y2: 604.02,
    xlinkHref: "#linear-gradient-90"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-100",
    x1: 1416.36,
    y1: 604.56,
    x2: 1416.36,
    y2: 610.45,
    xlinkHref: "#linear-gradient-90"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-101",
    x1: 1416.36,
    y1: 610.86,
    x2: 1416.36,
    y2: 615.75,
    xlinkHref: "#linear-gradient-90"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-102",
    x1: 1396.42,
    y1: 546.38,
    x2: 1396.42,
    y2: 622.59,
    xlinkHref: "#linear-gradient-90"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-103",
    x1: 1436.29,
    y1: 546.38,
    x2: 1436.29,
    y2: 622.59,
    xlinkHref: "#linear-gradient-90"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_4-3",
    x1: 1297.86,
    x2: 1297.86,
    xlinkHref: "#New_Gradient_Swatch_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-3",
    x1: 1297.86,
    x2: 1297.86,
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-104",
    x1: 1297.86,
    x2: 1297.86,
    xlinkHref: "#linear-gradient-76"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-105",
    x1: 1297.83,
    y1: 569.83,
    x2: 1297.83,
    y2: 670.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#58595b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#68696b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#929495"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d1d3d4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-106",
    x1: 1297.86,
    y1: 638.92,
    x2: 1297.86,
    y2: 601.67,
    gradientTransform: "translate(1702.46 -759.99) rotate(80.78)",
    xlinkHref: "#linear-gradient-70"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-107",
    x1: 1297.86,
    y1: 634.04,
    x2: 1297.86,
    y2: 607.41,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient-70"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_4-4",
    x1: 1534.55,
    x2: 1534.55,
    xlinkHref: "#New_Gradient_Swatch_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-4",
    x1: 1534.55,
    x2: 1534.55,
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-108",
    x1: 1534.55,
    x2: 1534.55,
    xlinkHref: "#linear-gradient-76"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-109",
    x1: 1534.52,
    x2: 1534.52,
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-110",
    x1: 1534.55,
    y1: 638.92,
    x2: 1534.55,
    y2: 601.67,
    gradientTransform: "translate(888.22 -903.35) rotate(45)",
    xlinkHref: "#linear-gradient-70"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-111",
    x1: 1534.55,
    y1: 634.04,
    x2: 1534.55,
    y2: 607.41,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient-70"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-112",
    x1: 212.85,
    y1: 213.83,
    x2: 212.85,
    y2: 520.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#e2e3e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#d9dadb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#c8cacc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bcbec0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-113",
    x1: 110.22,
    y1: 560.37,
    x2: 110.22,
    y2: 525.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#58595b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#747577"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#8e8f91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#a2a4a6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#b1b2b4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#b9bbbd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#bcbec0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#b8babc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#adaeb0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#9a9b9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#807f81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#5e5c5e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#353233"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231f20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_11_cop",
    x1: 96.73,
    y1: 619.73,
    x2: 96.73,
    y2: 627.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#8a8e9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#8a8e9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#e3c8af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-114",
    x1: 32.38,
    y1: 520.68,
    x2: 32.38,
    y2: 628.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#939598"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-115",
    x1: 1806.85,
    y1: 532.68,
    x2: 1806.85,
    y2: 615.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#444345"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#504f51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#636364"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#7e7e80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#a1a2a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#cbcdce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d1d3d4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-116",
    x1: 1806.85,
    y1: 489.27,
    x2: 1806.85,
    y2: 577.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#808285"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#85878a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#a6a8aa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#bdbfc1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#cccecf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d1d3d4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-117",
    x1: 1800.26,
    y1: 528.49,
    x2: 1800.26,
    y2: 578.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#808285"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#959799"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#b5b7b9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#c9cbcc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d1d3d4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-118",
    x1: 317.04,
    y1: 369.71,
    x2: 317.04,
    y2: 257.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#eeefef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#c4c5c7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#939598"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-119",
    x1: 317.04,
    y1: 358.94,
    x2: 317.04,
    y2: 268.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#d4d6d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#e4e5e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#eeefef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f1f2f2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-120",
    x1: 1143.71,
    y1: 1.28,
    x2: 1143.71,
    y2: 480.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#dfe0e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bcbec0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-121",
    x1: 228.59,
    y1: 432.06,
    x2: 228.59,
    y2: 415.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a7a9ac"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-122",
    x1: 209.05,
    y1: 420.47,
    x2: 209.05,
    y2: 427.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-123",
    x1: 246.63,
    x2: 246.63,
    xlinkHref: "#linear-gradient-122"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-124",
    x1: 227.84,
    y1: 421.43,
    x2: 227.84,
    y2: 426.56,
    xlinkHref: "#linear-gradient-84"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-125",
    x1: 84.75,
    y1: 500.52,
    x2: 84.75,
    y2: 511.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbb040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f15a29"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-126",
    x1: 7.62,
    y1: 356.93,
    x2: 18.41,
    y2: 388.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#8a8e9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#8b8f9e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#9296a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#9ea1ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#afb2bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#c5c7ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#dfe1e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#c5c7ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#9a9daa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#8a8e9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#8f867e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#938167"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-127",
    x1: 12.87,
    y1: 261.24,
    x2: 12.87,
    y2: 352.51,
    xlinkHref: "#linear-gradient-126"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-128",
    x1: -1207.04,
    y1: 511.57,
    x2: -1207.04,
    y2: 492.06,
    gradientTransform: "translate(2338.23 1003.18) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ed1c24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#be1e2d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-129",
    x1: -1232.07,
    y1: 491.89,
    x2: -1232.07,
    y2: 512.44,
    gradientTransform: "translate(2388.29 1003.18) scale(1 -1)",
    xlinkHref: "#linear-gradient-125"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-130",
    x1: -584.56,
    x2: -584.56,
    gradientTransform: "translate(1093.28 1003.18) scale(1 -1)",
    xlinkHref: "#linear-gradient-128"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-131",
    x1: -609.59,
    y1: 491.89,
    x2: -609.59,
    y2: 512.44,
    gradientTransform: "translate(1143.34 1003.18) scale(1 -1)",
    xlinkHref: "#linear-gradient-125"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-132",
    x1: -1829.51,
    x2: -1829.51,
    gradientTransform: "translate(3583.19 1003.18) scale(1 -1)",
    xlinkHref: "#linear-gradient-128"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-133",
    x1: -1854.54,
    y1: 491.89,
    x2: -1854.54,
    y2: 512.44,
    gradientTransform: "translate(3633.25 1003.18) scale(1 -1)",
    xlinkHref: "#linear-gradient-125"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-171"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "truck1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-169"
  }, /*#__PURE__*/React.createElement("image", {
    className: "cls-168",
    width: 1857,
    height: 88,
    transform: "translate(-.93 712.59)",
    xlinkHref: "data:image/png;base64,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"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-46",
    x: 367.39,
    y: 473.89,
    width: 1446.05,
    height: 59.93
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-139",
    d: "M676.13,580.98c-66.22,0-92.91,9.07-112.4,15.7-10.84,3.68-18.68,6.34-30.09,6.34h-166.1c-18.02,0-45.37-41.1-58.37-67.01-1.55-3.08-5.3-4.33-8.38-2.78-3.08,1.55-4.33,5.3-2.78,8.38,3.79,7.56,37.98,73.9,69.54,73.9h166.1c13.48,0,23.04-3.25,34.11-7.01,18.66-6.34,44.23-15.03,108.38-15.03h1073.11v-12.5H676.13Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 777.99,
    y: 569.96,
    width: 181.17,
    height: 31.29
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-155",
    d: "M1615.73,577.16l-6.29,4.39v48.83l6.29,4.39c2.35,1.64,5.28,2.54,8.3,2.54h155.42c3.01,0,5.94-.89,8.3-2.54l6.29-4.39h0v-48.83h0l-6.29-4.39c-2.35-1.64-5.28-2.54-8.3-2.54h-155.42c-3.02,0-5.94.89-8.3,2.54Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-145",
    x: 1677.32,
    y: 513.66,
    width: 48.83,
    height: 184.59,
    transform: "translate(1095.77 2307.69) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-156",
    x: 1790.45,
    y: 583.82,
    width: 5.86,
    height: 1.31,
    transform: "translate(2377.85 -1208.9) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-154",
    x: 1787.87,
    y: 583.62,
    width: 5.86,
    height: 1.71,
    transform: "translate(2375.28 -1206.32) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-160",
    x: 1784.69,
    y: 583.5,
    width: 5.86,
    height: 1.96,
    transform: "translate(2372.1 -1203.14) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-161",
    x: 1780.86,
    y: 583.29,
    width: 5.86,
    height: 2.38,
    transform: "translate(2368.27 -1199.31) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-159",
    x: 1776.36,
    y: 583.08,
    width: 5.86,
    height: 2.79,
    transform: "translate(2363.77 -1194.81) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 1771.32,
    y: 582.95,
    width: 5.86,
    height: 3.05,
    transform: "translate(2358.73 -1189.77) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 1765.74,
    y: 582.75,
    width: 5.86,
    height: 3.46,
    transform: "translate(2353.14 -1184.19) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-66",
    x: 1759.69,
    y: 582.64,
    width: 5.86,
    height: 3.67,
    transform: "translate(2347.09 -1178.14) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-63",
    x: 1753.02,
    y: 582.54,
    width: 5.86,
    height: 3.88,
    transform: "translate(2340.42 -1171.47) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-64",
    x: 1746.09,
    y: 582.38,
    width: 5.86,
    height: 4.19,
    transform: "translate(2333.49 -1164.54) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-65",
    x: 1738.65,
    y: 582.31,
    width: 5.86,
    height: 4.34,
    transform: "translate(2326.06 -1157.11) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-74",
    x: 1731,
    y: 582.16,
    width: 5.86,
    height: 4.63,
    transform: "translate(2318.41 -1149.45) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-70",
    x: 1722.99,
    y: 582.16,
    width: 5.86,
    height: 4.63,
    transform: "translate(2310.39 -1141.44) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-68",
    x: 1714.87,
    y: 582.06,
    width: 5.86,
    height: 4.83,
    transform: "translate(2302.27 -1133.32) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 1706.65,
    y: 582.06,
    width: 5.86,
    height: 4.83,
    transform: "translate(2294.05 -1125.1) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 1607.16,
    y: 583.82,
    width: 5.86,
    height: 1.31,
    transform: "translate(1025.61 2194.57) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-69",
    x: 1609.74,
    y: 583.62,
    width: 5.86,
    height: 1.71,
    transform: "translate(1028.19 2197.14) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-76",
    x: 1612.92,
    y: 583.5,
    width: 5.86,
    height: 1.97,
    transform: "translate(1031.37 2200.32) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-72",
    x: 1616.74,
    y: 583.29,
    width: 5.86,
    height: 2.38,
    transform: "translate(1035.2 2204.15) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 1621.24,
    y: 583.08,
    width: 5.86,
    height: 2.79,
    transform: "translate(1039.7 2208.65) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 1626.28,
    y: 582.95,
    width: 5.86,
    height: 3.05,
    transform: "translate(1044.74 2213.69) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-78",
    x: 1631.87,
    y: 582.75,
    width: 5.86,
    height: 3.46,
    transform: "translate(1050.32 2219.28) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-62",
    x: 1637.92,
    y: 582.64,
    width: 5.86,
    height: 3.67,
    transform: "translate(1056.37 2225.33) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-79",
    x: 1644.59,
    y: 582.54,
    width: 5.86,
    height: 3.88,
    transform: "translate(1063.04 2232) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-77",
    x: 1651.52,
    y: 582.38,
    width: 5.86,
    height: 4.19,
    transform: "translate(1069.97 2238.93) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-61",
    x: 1658.95,
    y: 582.31,
    width: 5.86,
    height: 4.34,
    transform: "translate(1077.4 2246.36) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-52",
    x: 1666.6,
    y: 582.16,
    width: 5.86,
    height: 4.63,
    transform: "translate(1085.06 2254.01) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 1674.62,
    y: 582.16,
    width: 5.86,
    height: 4.63,
    transform: "translate(1093.07 2262.03) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 1682.74,
    y: 582.06,
    width: 5.86,
    height: 4.83,
    transform: "translate(1101.19 2270.15) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-53",
    x: 1690.96,
    y: 582.06,
    width: 5.86,
    height: 4.83,
    transform: "translate(1109.41 2278.37) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-51",
    x: 1698.8,
    y: 582.1,
    width: 5.86,
    height: 4.76,
    transform: "translate(1117.25 2286.21) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-58",
    x: 1790.45,
    y: 626.79,
    width: 5.86,
    height: 1.31,
    transform: "translate(2420.82 -1165.93) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 1787.87,
    y: 626.59,
    width: 5.86,
    height: 1.71,
    transform: "translate(2418.24 -1163.35) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-56",
    x: 1784.69,
    y: 626.46,
    width: 5.86,
    height: 1.96,
    transform: "translate(2415.06 -1160.17) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 1780.86,
    y: 626.26,
    width: 5.86,
    height: 2.38,
    transform: "translate(2411.24 -1156.35) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-50",
    x: 1776.36,
    y: 626.05,
    width: 5.86,
    height: 2.79,
    transform: "translate(2406.74 -1151.85) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-57",
    x: 1771.32,
    y: 625.92,
    width: 5.86,
    height: 3.05,
    transform: "translate(2401.7 -1146.8) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-88",
    x: 1765.74,
    y: 625.71,
    width: 5.86,
    height: 3.46,
    transform: "translate(2396.11 -1141.22) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 1759.69,
    y: 625.61,
    width: 5.86,
    height: 3.67,
    transform: "translate(2390.06 -1135.17) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-86",
    x: 1753.02,
    y: 625.51,
    width: 5.86,
    height: 3.88,
    transform: "translate(2383.39 -1128.5) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 1746.09,
    y: 625.35,
    width: 5.86,
    height: 4.19,
    transform: "translate(2376.46 -1121.57) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 1738.65,
    y: 625.27,
    width: 5.86,
    height: 4.34,
    transform: "translate(2369.03 -1114.14) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-80",
    x: 1731,
    y: 625.13,
    width: 5.86,
    height: 4.63,
    transform: "translate(2361.38 -1106.48) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-81",
    x: 1722.99,
    y: 625.13,
    width: 5.86,
    height: 4.63,
    transform: "translate(2353.36 -1098.47) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-85",
    x: 1714.87,
    y: 625.03,
    width: 5.86,
    height: 4.83,
    transform: "translate(2345.24 -1090.35) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: 1706.65,
    y: 625.03,
    width: 5.86,
    height: 4.83,
    transform: "translate(2337.02 -1082.13) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-84",
    x: 1607.16,
    y: 626.79,
    width: 5.86,
    height: 1.31,
    transform: "translate(982.64 2237.54) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-98",
    x: 1609.74,
    y: 626.59,
    width: 5.86,
    height: 1.71,
    transform: "translate(985.22 2240.11) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-96",
    x: 1612.92,
    y: 626.46,
    width: 5.86,
    height: 1.97,
    transform: "translate(988.4 2243.29) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-97",
    x: 1616.74,
    y: 626.26,
    width: 5.86,
    height: 2.38,
    transform: "translate(992.23 2247.12) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-95",
    x: 1621.24,
    y: 626.05,
    width: 5.86,
    height: 2.79,
    transform: "translate(996.73 2251.62) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-99",
    x: 1626.28,
    y: 625.92,
    width: 5.86,
    height: 3.05,
    transform: "translate(1001.77 2256.66) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 1631.87,
    y: 625.71,
    width: 5.86,
    height: 3.46,
    transform: "translate(1007.35 2262.24) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-94",
    x: 1637.92,
    y: 625.61,
    width: 5.86,
    height: 3.67,
    transform: "translate(1013.4 2268.29) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: 1644.59,
    y: 625.51,
    width: 5.86,
    height: 3.88,
    transform: "translate(1020.07 2274.97) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-92",
    x: 1651.52,
    y: 625.35,
    width: 5.86,
    height: 4.19,
    transform: "translate(1027 2281.89) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-90",
    x: 1658.95,
    y: 625.27,
    width: 5.86,
    height: 4.34,
    transform: "translate(1034.44 2289.33) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-100",
    x: 1666.6,
    y: 625.13,
    width: 5.86,
    height: 4.63,
    transform: "translate(1042.09 2296.98) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-101",
    x: 1674.62,
    y: 625.13,
    width: 5.86,
    height: 4.63,
    transform: "translate(1050.1 2305) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-102",
    x: 1682.74,
    y: 625.03,
    width: 5.86,
    height: 4.83,
    transform: "translate(1058.22 2313.11) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-113",
    x: 1690.96,
    y: 625.03,
    width: 5.86,
    height: 4.83,
    transform: "translate(1066.44 2321.34) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-115",
    x: 1698.8,
    y: 625.07,
    width: 5.86,
    height: 4.76,
    transform: "translate(1074.29 2329.18) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-103",
    x: 1682.15,
    y: 513.66,
    width: 39.17,
    height: 184.59,
    transform: "translate(1095.77 2307.69) rotate(-90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-145",
    d: "M1626.93,618.03l-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-2.86-2.06-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.15.11-.24.25-.24.39v1.42l2.35-1.7c.39-.28,1.09-.28,1.48,0l1.72,1.24h0l1.14.82,1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l2.86,2.06,1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l1.72,1.24,1.14.82,2.86-2.06c.39-.28,1.09-.28,1.48,0l1.72,1.24,1.14.82,1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l1.72,1.24h0s1.14.82,1.14.82l1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l2.12,1.53c.39.28,1.09.28,1.48,0l2.12-1.53c.39-.28,1.09-.28,1.48,0l2.12,1.53c.39.28,1.09.28,1.48,0l2.86-2.06,2.37,1.7-.12.07,1.17.69.18.13h.02s.02,0,.02,0l3.72-2.2c.38-.22.97-.22,1.34,0l2.33,1.38h0l1.39.82,1.39-.82,2.33-1.38c.38-.22.97-.22,1.34,0l3.72,2.2,1.39-.82,2.33-1.38c.38-.22.97-.22,1.34,0l2.33,1.38,1.39.82,3.72-2.2c.38-.22.97-.22,1.34,0l2.33,1.38,1.39.82,1.39-.82,2.33-1.38c.38-.22.97-.22,1.34,0l2.33,1.38h0s1.39.82,1.39.82l1.39-.82,2.33-1.38c.38-.22.97-.22,1.34,0l3.05,1.8c.38.22.97.22,1.34,0l3.05-1.8c.38-.22.97-.22,1.34,0l3.05,1.8c.38.22.97.22,1.34,0l3.05-1.8c.38-.22.97-.22,1.34,0l3.72,2.2.04-.02.03.02.29-.21,1.03-.61-.1-.06,2.38-1.71,2.46,1.77h0l1.14.82,1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l2.86,2.06,1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l1.72,1.24,1.14.82,2.86-2.06c.39-.28,1.09-.28,1.48,0l1.72,1.24,1.14.82,1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l1.72,1.24h0s1.14.82,1.14.82l1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l2.12,1.53c.39.28,1.09.28,1.48,0l2.12-1.53c.39-.28,1.09-.28,1.48,0l2.12,1.53c.39.28,1.09.28,1.48,0l2.12-1.53c.39-.28,1.09-.28,1.48,0l2.36,1.7v-1.42c0-.14-.08-.28-.24-.39l-1.73-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-2.86,2.06c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-2.86-2.06-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.82,1.31c-.36.26-1.01.28-1.41.04l-2.3-1.36-1.39-.82-1.39.82-2.33,1.38c-.38.22-.97.22-1.34,0l-2.33-1.38-1.39-.82-1.39.82-2.33,1.38c-.38.22-.97.22-1.34,0l-2.33-1.38-1.39-.82-1.39.82-2.33,1.38c-.38.22-.97.22-1.34,0l-2.33-1.38-1.39-.82-1.39.82-2.33,1.38c-.38.22-.97.22-1.34,0l-2.33-1.38-1.39-.82-3.72,2.2c-.38.22-.97.22-1.34,0l-2.33-1.38-1.39-.82-1.39.82-2.33,1.38c-.38.22-.97.22-1.34,0l-3.72-2.2-1.39.82-2.33,1.38c-.38.22-.97.22-1.34,0l-2.33-1.38-1.39-.82-1.39.82-2.28,1.35c-.4.24-1.05.22-1.41-.04l-1.81-1.3-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-2.86,2.06c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-145",
    d: "M1626.93,608.57l-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-2.86-2.06-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.15.11-.24.25-.24.39v1.42l2.35-1.7c.39-.28,1.09-.28,1.48,0l1.72,1.24h0l1.14.82,1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l2.86,2.06,1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l1.72,1.24,1.14.82,2.86-2.06c.39-.28,1.09-.28,1.48,0l1.72,1.24,1.14.82,1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l1.72,1.24h0s1.14.82,1.14.82l1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l2.12,1.53c.39.28,1.09.28,1.48,0l2.12-1.53c.39-.28,1.09-.28,1.48,0l2.12,1.53c.39.28,1.09.28,1.48,0l2.86-2.06,2.37,1.7-.12.07,1.17.69.18.13h.02s.02,0,.02,0l3.72-2.2c.38-.22.97-.22,1.34,0l2.33,1.38h0l1.39.82,1.39-.82,2.33-1.38c.38-.22.97-.22,1.34,0l3.72,2.2,1.39-.82,2.33-1.38c.38-.22.97-.22,1.34,0l2.33,1.38,1.39.82,3.72-2.2c.38-.22.97-.22,1.34,0l2.33,1.38,1.39.82,1.39-.82,2.33-1.38c.38-.22.97-.22,1.34,0l2.33,1.38h0s1.39.82,1.39.82l1.39-.82,2.33-1.38c.38-.22.97-.22,1.34,0l3.05,1.8c.38.22.97.22,1.34,0l3.05-1.8c.38-.22.97-.22,1.34,0l3.05,1.8c.38.22.97.22,1.34,0l3.05-1.8c.38-.22.97-.22,1.34,0l3.72,2.2.04-.02.03.02.29-.21,1.03-.61-.1-.06,2.38-1.71,2.46,1.77h0l1.14.82,1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l2.86,2.06,1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l1.72,1.24,1.14.82,2.86-2.06c.39-.28,1.09-.28,1.48,0l1.72,1.24,1.14.82,1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l1.72,1.24h0s1.14.82,1.14.82l1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l2.12,1.53c.39.28,1.09.28,1.48,0l2.12-1.53c.39-.28,1.09-.28,1.48,0l2.12,1.53c.39.28,1.09.28,1.48,0l2.12-1.53c.39-.28,1.09-.28,1.48,0l2.36,1.7v-1.42c0-.14-.08-.28-.24-.39l-1.73-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-2.86,2.06c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-2.86-2.06-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.82,1.31c-.36.26-1.01.28-1.41.04l-2.3-1.36-1.39-.82-1.39.82-2.33,1.38c-.38.22-.97.22-1.34,0l-2.33-1.38-1.39-.82-1.39.82-2.33,1.38c-.38.22-.97.22-1.34,0l-2.33-1.38-1.39-.82-1.39.82-2.33,1.38c-.38.22-.97.22-1.34,0l-2.33-1.38-1.39-.82-1.39.82-2.33,1.38c-.38.22-.97.22-1.34,0l-2.33-1.38-1.39-.82-3.72,2.2c-.38.22-.97.22-1.34,0l-2.33-1.38-1.39-.82-1.39.82-2.33,1.38c-.38.22-.97.22-1.34,0l-3.72-2.2-1.39.82-2.33,1.38c-.38.22-.97.22-1.34,0l-2.33-1.38-1.39-.82-1.39.82-2.28,1.35c-.4.24-1.05.22-1.41-.04l-1.81-1.3-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-2.86,2.06c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-145",
    d: "M1626.93,599.12l-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-2.86-2.06-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.15.11-.24.25-.24.39v1.42l2.35-1.7c.39-.28,1.09-.28,1.48,0l1.72,1.24h0l1.14.82,1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l2.86,2.06,1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l1.72,1.24,1.14.82,2.86-2.06c.39-.28,1.09-.28,1.48,0l1.72,1.24,1.14.82,1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l1.72,1.24h0s1.14.82,1.14.82l1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l2.12,1.53c.39.28,1.09.28,1.48,0l2.12-1.53c.39-.28,1.09-.28,1.48,0l2.12,1.53c.39.28,1.09.28,1.48,0l2.86-2.06,2.37,1.7-.12.07,1.17.69.18.13h.02s.02,0,.02,0l3.72-2.2c.38-.22.97-.22,1.34,0l2.33,1.38h0l1.39.82,1.39-.82,2.33-1.38c.38-.22.97-.22,1.34,0l3.72,2.2,1.39-.82,2.33-1.38c.38-.22.97-.22,1.34,0l2.33,1.38,1.39.82,3.72-2.2c.38-.22.97-.22,1.34,0l2.33,1.38,1.39.82,1.39-.82,2.33-1.38c.38-.22.97-.22,1.34,0l2.33,1.38h0s1.39.82,1.39.82l1.39-.82,2.33-1.38c.38-.22.97-.22,1.34,0l3.05,1.8c.38.22.97.22,1.34,0l3.05-1.8c.38-.22.97-.22,1.34,0l3.05,1.8c.38.22.97.22,1.34,0l3.05-1.8c.38-.22.97-.22,1.34,0l3.72,2.2.04-.02.03.02.29-.21,1.03-.61-.1-.06,2.38-1.71,2.46,1.77h0l1.14.82,1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l2.86,2.06,1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l1.72,1.24,1.14.82,2.86-2.06c.39-.28,1.09-.28,1.48,0l1.72,1.24,1.14.82,1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l1.72,1.24h0s1.14.82,1.14.82l1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l2.12,1.53c.39.28,1.09.28,1.48,0l2.12-1.53c.39-.28,1.09-.28,1.48,0l2.12,1.53c.39.28,1.09.28,1.48,0l2.12-1.53c.39-.28,1.09-.28,1.48,0l2.36,1.7v-1.42c0-.14-.08-.28-.24-.39l-1.73-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-2.86,2.06c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-2.86-2.06-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.82,1.31c-.36.26-1.01.28-1.41.04l-2.3-1.36-1.39-.82-1.39.82-2.33,1.38c-.38.22-.97.22-1.34,0l-2.33-1.38-1.39-.82-1.39.82-2.33,1.38c-.38.22-.97.22-1.34,0l-2.33-1.38-1.39-.82-1.39.82-2.33,1.38c-.38.22-.97.22-1.34,0l-2.33-1.38-1.39-.82-1.39.82-2.33,1.38c-.38.22-.97.22-1.34,0l-2.33-1.38-1.39-.82-3.72,2.2c-.38.22-.97.22-1.34,0l-2.33-1.38-1.39-.82-1.39.82-2.33,1.38c-.38.22-.97.22-1.34,0l-3.72-2.2-1.39.82-2.33,1.38c-.38.22-.97.22-1.34,0l-2.33-1.38-1.39-.82-1.39.82-2.28,1.35c-.4.24-1.05.22-1.41-.04l-1.81-1.3-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-2.86,2.06c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-145",
    d: "M1626.93,589.66l-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-2.86-2.06-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.15.11-.24.25-.24.39v1.42l2.35-1.7c.39-.28,1.09-.28,1.48,0l1.72,1.24h0l1.14.82,1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l2.86,2.06,1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l1.72,1.24,1.14.82,2.86-2.06c.39-.28,1.09-.28,1.48,0l1.72,1.24,1.14.82,1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l1.72,1.24h0s1.14.82,1.14.82l1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l2.12,1.53c.39.28,1.09.28,1.48,0l2.12-1.53c.39-.28,1.09-.28,1.48,0l2.12,1.53c.39.28,1.09.28,1.48,0l2.86-2.06,2.37,1.7-.12.07,1.17.69.18.13h.02s.02,0,.02,0l3.72-2.2c.38-.22.97-.22,1.34,0l2.33,1.38h0l1.39.82,1.39-.82,2.33-1.38c.38-.22.97-.22,1.34,0l3.72,2.2,1.39-.82,2.33-1.38c.38-.22.97-.22,1.34,0l2.33,1.38,1.39.82,3.72-2.2c.38-.22.97-.22,1.34,0l2.33,1.38,1.39.82,1.39-.82,2.33-1.38c.38-.22.97-.22,1.34,0l2.33,1.38h0s1.39.82,1.39.82l1.39-.82,2.33-1.38c.38-.22.97-.22,1.34,0l3.05,1.8c.38.22.97.22,1.34,0l3.05-1.8c.38-.22.97-.22,1.34,0l3.05,1.8c.38.22.97.22,1.34,0l3.05-1.8c.38-.22.97-.22,1.34,0l3.72,2.2.04-.02.03.02.29-.21,1.03-.61-.1-.06,2.38-1.71,2.46,1.77h0l1.14.82,1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l2.86,2.06,1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l1.72,1.24,1.14.82,2.86-2.06c.39-.28,1.09-.28,1.48,0l1.72,1.24,1.14.82,1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l1.72,1.24h0s1.14.82,1.14.82l1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l2.12,1.53c.39.28,1.09.28,1.48,0l2.12-1.53c.39-.28,1.09-.28,1.48,0l2.12,1.53c.39.28,1.09.28,1.48,0l2.12-1.53c.39-.28,1.09-.28,1.48,0l2.36,1.7v-1.42c0-.14-.08-.28-.24-.39l-1.73-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-2.86,2.06c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-2.86-2.06-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.82,1.31c-.36.26-1.01.28-1.41.04l-2.3-1.36-1.39-.82-1.39.82-2.33,1.38c-.38.22-.97.22-1.34,0l-2.33-1.38-1.39-.82-1.39.82-2.33,1.38c-.38.22-.97.22-1.34,0l-2.33-1.38-1.39-.82-1.39.82-2.33,1.38c-.38.22-.97.22-1.34,0l-2.33-1.38-1.39-.82-1.39.82-2.33,1.38c-.38.22-.97.22-1.34,0l-2.33-1.38-1.39-.82-3.72,2.2c-.38.22-.97.22-1.34,0l-2.33-1.38-1.39-.82-1.39.82-2.33,1.38c-.38.22-.97.22-1.34,0l-3.72-2.2-1.39.82-2.33,1.38c-.38.22-.97.22-1.34,0l-2.33-1.38-1.39-.82-1.39.82-2.28,1.35c-.4.24-1.05.22-1.41-.04l-1.81-1.3-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-2.86,2.06c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-148",
    x: 1609.44,
    y: 574.63,
    width: 184.59,
    height: 37.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-145",
    x: 730.7,
    y: 593.2,
    width: 567.45,
    height: 13.18,
    transform: "translate(60.75 -92.54) rotate(5.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-145",
    d: "M73.52,420.31h301.54c13.6,0,24.64,11.04,24.64,24.64v100.14H73.52v-124.77h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-145",
    d: "M318.69,607.84h-99.68c-19.41,0-38.4-3.9-54.92-11.27-12.7-5.67-27.33-8.66-42.31-8.66h-61.44v-19.3h61.44c19.4,0,38.39,3.9,54.91,11.27,12.7,5.67,27.33,8.67,42.31,8.67h99.68c12.07,0,24.18-2,35.02-5.78l19.12-6.66c14.08-4.91,29.77-7.5,45.38-7.5h1382.27v19.3H418.21c-12.07,0-24.17,2-35.02,5.78l-19.12,6.67c-14.07,4.91-29.77,7.5-45.38,7.5Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-112",
    x: 60.34,
    y: 528.21,
    width: 1753.11,
    height: 45.06
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-145",
    d: "M395.7,474.22h0v-188.86h10.68v178.18c0,5.9-4.78,10.68-10.68,10.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-110",
    d: "M395.45,284.16v46.98h16.47v-39.87c0-3.93-3.18-7.11-7.11-7.11h-9.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "M431.14,522.33h-24.76v-33.44c0-4.01-3.25-7.26-7.26-7.26s-7.26,3.25-7.26,7.26v70.4c0,4.26,3.45,7.71,7.71,7.71h31.58c4.26,0,7.71-3.45,7.71-7.71v-29.25c0-4.26-3.45-7.71-7.71-7.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-114",
    d: "M415.86,552.21h24.76v33.44c0,4.01,3.25,7.26,7.26,7.26s7.26-3.25,7.26-7.26v-70.4c0-4.26-3.45-7.71-7.71-7.71h-31.58c-4.26,0-7.71,3.45-7.71,7.71v29.25c0,4.26,3.45,7.71,7.71,7.71Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-118",
    cx: 431.65,
    cy: 535.43,
    r: 34.46
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-116",
    cx: 431.65,
    cy: 535.43,
    r: 27.78,
    transform: "translate(-188.64 832.52) rotate(-76.72)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-117",
    cx: 431.65,
    cy: 535.43,
    r: 21.32
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-119",
    cx: 431.65,
    cy: 535.43,
    r: 17.19
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-145",
    d: "M262.38,529.61c-50.2,0-90.9,40.7-90.9,90.9s40.7,90.9,90.9,90.9,90.9-40.7,90.9-90.9-40.7-90.9-90.9-90.9ZM262.38,667.6c-26.01,0-47.09-21.08-47.09-47.09s21.09-47.09,47.09-47.09,47.09,21.08,47.09,47.09-21.09,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M354.68,623.21v-4.71h-5.81c-.02-.95-.04-1.9-.09-2.84l5.78-.51-.41-4.7-5.76.5c-.1-.94-.22-1.88-.36-2.81l5.71-1.01-.82-4.64-5.68,1c-.19-.93-.4-1.85-.62-2.77l5.61-1.5-1.22-4.55-5.58,1.5c-.27-.91-.55-1.81-.84-2.71l5.45-1.98-1.61-4.43-5.43,1.98c-.34-.88-.69-1.76-1.06-2.63l5.24-2.44-1.99-4.27-5.24,2.44c-.42-.85-.85-1.69-1.29-2.53l5.01-2.89-2.36-4.08-5,2.88c-.49-.81-1.01-1.6-1.53-2.39l4.76-3.33-2.7-3.86-4.74,3.32c-.56-.76-1.14-1.51-1.73-2.25l4.46-3.74-3.03-3.61-4.44,3.73c-.62-.71-1.26-1.41-1.91-2.1l4.11-4.11-3.33-3.33-4.1,4.1c-.68-.65-1.37-1.3-2.08-1.93l3.73-4.45-3.61-3.03-3.73,4.44c-.74-.59-1.47-1.19-2.23-1.75l3.32-4.75-3.86-2.7-3.31,4.73c-.79-.52-1.58-1.03-2.39-1.53l2.9-5.02-4.08-2.36-2.88,5c-.83-.45-1.67-.88-2.52-1.31l2.45-5.26-4.27-1.99-2.44,5.24c-.87-.38-1.74-.74-2.62-1.09l1.98-5.45-4.43-1.61-1.98,5.43c-.9-.3-1.79-.6-2.7-.87l1.5-5.59-4.55-1.22-1.5,5.58c-.92-.22-1.84-.45-2.77-.64l1-5.7-4.64-.82-1,5.68c-.93-.14-1.87-.25-2.82-.36l.51-5.79-4.7-.41-.51,5.77c-.94-.06-1.89-.1-2.83-.13v-5.82h-4.71v5.81c-.95.02-1.9.04-2.84.09l-.51-5.78-4.7.41.5,5.76c-.94.1-1.88.22-2.81.36l-1.01-5.71-4.64.82,1,5.68c-.93.19-1.85.4-2.77.62l-1.5-5.61-4.55,1.22,1.5,5.58c-.91.27-1.81.55-2.71.84l-1.98-5.45-4.43,1.61,1.98,5.43c-.88.34-1.76.69-2.63,1.06l-2.44-5.24-4.27,1.99,2.44,5.24c-.85.42-1.69.85-2.53,1.29l-2.89-5.01-4.08,2.36,2.88,5c-.81.49-1.6,1.01-2.39,1.53l-3.33-4.76-3.86,2.7,3.32,4.74c-.76.56-1.51,1.14-2.25,1.73l-3.74-4.46-3.61,3.03,3.73,4.44c-.71.62-1.41,1.26-2.1,1.91l-4.11-4.11-3.33,3.33,4.1,4.1c-.65.68-1.3,1.37-1.93,2.08l-4.45-3.73-3.03,3.61,4.44,3.73c-.59.74-1.19,1.47-1.75,2.23l-4.75-3.32-2.7,3.86,4.73,3.31c-.52.79-1.03,1.59-1.53,2.39l-5.02-2.9-2.36,4.08,5,2.88c-.45.83-.88,1.67-1.31,2.52l-5.26-2.45-1.99,4.27,5.23,2.44c-.38.87-.74,1.74-1.09,2.62l-5.45-1.98-1.61,4.43,5.43,1.98c-.3.9-.6,1.79-.87,2.7l-5.59-1.5-1.22,4.55,5.58,1.5c-.22.92-.45,1.84-.64,2.77l-5.7-1-.82,4.64,5.68,1c-.14.93-.25,1.87-.36,2.82l-5.79-.51-.41,4.7,5.77.51c-.06.94-.1,1.89-.13,2.83h-5.82v4.71h5.8c.02.95.04,1.9.09,2.84l-5.78.51.41,4.7,5.76-.5c.1.94.22,1.88.36,2.82l-5.71,1.01.82,4.64,5.68-1c.19.93.4,1.85.62,2.77l-5.61,1.5,1.22,4.55,5.58-1.5c.27.91.55,1.81.84,2.71l-5.45,1.98,1.61,4.43,5.43-1.98c.34.88.69,1.76,1.06,2.63l-5.24,2.44,1.99,4.27,5.24-2.44c.42.85.85,1.69,1.29,2.53l-5.01,2.89,2.36,4.08,5-2.88c.49.81,1.01,1.6,1.53,2.39l-4.76,3.33,2.7,3.86,4.74-3.32c.56.76,1.14,1.51,1.73,2.25l-4.46,3.74,3.03,3.61,4.44-3.73c.62.71,1.26,1.41,1.91,2.1l-4.11,4.11,3.33,3.33,4.1-4.1c.68.65,1.37,1.3,2.08,1.93l-3.73,4.45,3.61,3.03,3.73-4.44c.74.59,1.47,1.19,2.23,1.75l-3.32,4.75,3.86,2.7,3.31-4.73c.79.52,1.58,1.03,2.39,1.53l-2.9,5.02,4.08,2.36,2.88-5c.83.45,1.67.88,2.52,1.31l-2.45,5.26,4.27,1.99,2.44-5.24c.87.38,1.74.74,2.62,1.09l-1.98,5.45,4.43,1.61,1.98-5.43c.9.3,1.79.6,2.7.87l-1.5,5.59,4.55,1.22,1.5-5.58c.92.22,1.84.45,2.77.64l-1,5.7,4.64.82,1-5.68c.93.14,1.87.25,2.82.36l-.51,5.79,4.7.41.5-5.77c.94.06,1.89.1,2.83.13v5.82h4.71v-5.81c.95-.02,1.9-.04,2.84-.09l.51,5.78,4.7-.41-.5-5.76c.94-.1,1.88-.22,2.82-.36l1.01,5.71,4.64-.82-1-5.68c.93-.19,1.85-.4,2.77-.62l1.5,5.61,4.55-1.22-1.5-5.58c.91-.27,1.81-.55,2.71-.84l1.98,5.45,4.43-1.61-1.98-5.43c.88-.34,1.76-.69,2.63-1.06l2.44,5.24,4.27-1.99-2.44-5.24c.85-.42,1.69-.85,2.53-1.29l2.89,5.01,4.08-2.36-2.88-5c.81-.49,1.6-1.01,2.39-1.53l3.33,4.76,3.86-2.7-3.32-4.74c.76-.56,1.51-1.14,2.25-1.73l3.74,4.46,3.61-3.03-3.73-4.44c.71-.62,1.41-1.26,2.1-1.91l4.11,4.11,3.33-3.33-4.1-4.1c.65-.68,1.3-1.37,1.93-2.08l4.45,3.73,3.03-3.61-4.44-3.73c.59-.74,1.19-1.47,1.75-2.23l4.75,3.32,2.7-3.86-4.73-3.31c.52-.79,1.03-1.59,1.53-2.39l5.02,2.9,2.36-4.08-5-2.88c.45-.83.88-1.67,1.31-2.52l5.26,2.45,1.99-4.27-5.23-2.44c.38-.87.74-1.74,1.09-2.62l5.45,1.98,1.61-4.43-5.43-1.98c.3-.9.6-1.79.87-2.7l5.59,1.5,1.22-4.55-5.58-1.5c.22-.92.45-1.84.64-2.77l5.7,1,.82-4.64-5.68-1c.14-.93.25-1.87.36-2.82l5.79.51.41-4.7-5.77-.51c.06-.94.1-1.89.13-2.83h5.82ZM262.38,667.6c-26.01,0-47.09-21.08-47.09-47.09s21.09-47.09,47.09-47.09,47.09,21.08,47.09,47.09-21.09,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M262.38,538.14c-45.49,0-82.37,36.88-82.37,82.37s36.88,82.37,82.37,82.37,82.37-36.88,82.37-82.37-36.88-82.37-82.37-82.37ZM262.38,667.6c-26.01,0-47.09-21.08-47.09-47.09s21.09-47.09,47.09-47.09,47.09,21.08,47.09,47.09-21.09,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-109",
    d: "M312.26,628.74c-1.08,1.93-2.53,3.14-4.13,3.14-3.34,0-6.05-5.16-6.05-11.52s2.71-11.52,6.05-11.52c1.57,0,2.99,1.17,4.07,3.04-1.32-7.68-4.36-14.76-8.73-20.84.61,2.14.44,4.02-.7,5.16-2.36,2.36-7.93.64-12.43-3.86-4.5-4.5-6.23-10.06-3.86-12.43,1.12-1.12,2.96-1.29,5.06-.72-6.11-4.32-13.22-7.3-20.92-8.56,1.93,1.08,3.13,2.53,3.13,4.13,0,3.34-5.16,6.05-11.52,6.05s-11.52-2.71-11.52-6.05c0-1.57,1.17-2.99,3.04-4.07-7.68,1.32-14.76,4.36-20.84,8.73,2.14-.61,4.02-.44,5.16.7,2.36,2.36.63,7.93-3.86,12.43-4.5,4.5-10.06,6.23-12.43,3.86-1.12-1.12-1.29-2.96-.72-5.06-4.32,6.11-7.3,13.22-8.56,20.92,1.08-1.93,2.53-3.14,4.13-3.14,3.34,0,6.05,5.16,6.05,11.52s-2.71,11.52-6.05,11.52c-1.57,0-2.99-1.17-4.07-3.04,1.32,7.68,4.36,14.76,8.73,20.84-.61-2.14-.44-4.02.7-5.16,2.37-2.36,7.93-.64,12.43,3.86,4.5,4.5,6.23,10.06,3.86,12.43-1.12,1.12-2.96,1.29-5.06.72,6.11,4.32,13.22,7.3,20.92,8.56-1.93-1.08-3.14-2.53-3.14-4.13,0-3.34,5.16-6.05,11.52-6.05s11.52,2.71,11.52,6.05c0,1.57-1.17,2.99-3.04,4.07,7.68-1.32,14.76-4.36,20.84-8.73-2.14.61-4.02.44-5.16-.7-2.36-2.37-.63-7.93,3.86-12.43s10.06-6.23,12.43-3.86c1.12,1.12,1.29,2.96.72,5.06,4.32-6.11,7.3-13.22,8.56-20.92Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-107",
    cx: 262.38,
    cy: 620.5,
    r: 31.07,
    transform: "translate(-392.14 780.1) rotate(-80.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-149",
    d: "M262.38,569.85c-27.98,0-50.66,22.68-50.66,50.66s22.68,50.66,50.66,50.66,50.66-22.68,50.66-50.66-22.68-50.66-50.66-50.66ZM262.38,668.11c-26.29,0-47.61-21.31-47.61-47.61s21.31-47.61,47.61-47.61,47.61,21.31,47.61,47.61-21.31,47.61-47.61,47.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-108",
    d: "M262.38,563.02c-31.75,0-57.48,25.74-57.48,57.48s25.74,57.48,57.48,57.48,57.48-25.74,57.48-57.48-25.74-57.48-57.48-57.48ZM262.38,670.39c-27.55,0-49.88-22.33-49.88-49.88s22.33-49.88,49.88-49.88,49.88,22.33,49.88,49.88-22.33,49.88-49.88,49.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M312.26,628.74c-1.08,1.93-2.53,3.14-4.13,3.14-3.34,0-6.05-5.16-6.05-11.52s2.71-11.52,6.05-11.52c1.57,0,2.99,1.17,4.07,3.04-1.32-7.68-4.36-14.76-8.73-20.84.61,2.14.44,4.02-.7,5.16-2.36,2.36-7.93.64-12.43-3.86-4.5-4.5-6.23-10.06-3.86-12.43,1.12-1.12,2.96-1.29,5.06-.72-6.11-4.32-13.22-7.3-20.92-8.56,1.93,1.08,3.13,2.53,3.13,4.13,0,3.34-5.16,6.05-11.52,6.05s-11.52-2.71-11.52-6.05c0-1.57,1.17-2.99,3.04-4.07-7.68,1.32-14.76,4.36-20.84,8.73,2.14-.61,4.02-.44,5.16.7,2.36,2.36.63,7.93-3.86,12.43-4.5,4.5-10.06,6.23-12.43,3.86-1.12-1.12-1.29-2.96-.72-5.06-4.32,6.11-7.3,13.22-8.56,20.92,1.08-1.93,2.53-3.14,4.13-3.14,3.34,0,6.05,5.16,6.05,11.52s-2.71,11.52-6.05,11.52c-1.57,0-2.99-1.17-4.07-3.04,1.32,7.68,4.36,14.76,8.73,20.84-.61-2.14-.44-4.02.7-5.16,2.37-2.36,7.93-.64,12.43,3.86,4.5,4.5,6.23,10.06,3.86,12.43-1.12,1.12-2.96,1.29-5.06.72,6.11,4.32,13.22,7.3,20.92,8.56-1.93-1.08-3.14-2.53-3.14-4.13,0-3.34,5.16-6.05,11.52-6.05s11.52,2.71,11.52,6.05c0,1.57-1.17,2.99-3.04,4.07,7.68-1.32,14.76-4.36,20.84-8.73-2.14.61-4.02.44-5.16-.7-2.36-2.37-.63-7.93,3.86-12.43s10.06-6.23,12.43-3.86c1.12,1.12,1.29,2.96.72,5.06,4.32-6.11,7.3-13.22,8.56-20.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-140",
    d: "M262.38,568.42c-28.77,0-52.09,23.32-52.09,52.09s23.32,52.09,52.09,52.09,52.09-23.32,52.09-52.09-23.32-52.09-52.09-52.09ZM262.38,669.46c-27.04,0-48.95-21.92-48.95-48.95s21.92-48.95,48.95-48.95,48.95,21.92,48.95,48.95-21.92,48.95-48.95,48.95Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-106",
    cx: 262.38,
    cy: 620.5,
    r: 18.8,
    transform: "translate(-401.81 733.3) rotate(-76.72)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-141",
    points: "264.85 641.63 260.68 641.63 258.6 645.24 260.68 648.85 264.85 648.85 266.94 645.24 264.85 641.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M264.81,645.24c0,1.13-.92,2.05-2.05,2.05s-2.05-.92-2.05-2.05.92-2.05,2.05-2.05,2.05.92,2.05,2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-141",
    points: "279.06 633.69 276.11 636.64 277.19 640.67 281.22 641.75 284.17 638.8 283.09 634.77 279.06 633.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M281.59,636.27c.8.8.8,2.09,0,2.89-.8.8-2.1.8-2.89,0s-.8-2.1,0-2.89c.8-.8,2.1-.8,2.89,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-141",
    points: "283.5 618.03 283.5 622.2 287.11 624.29 290.73 622.2 290.73 618.03 287.11 615.94 283.5 618.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M287.11,618.07c1.13,0,2.05.92,2.05,2.05s-.92,2.05-2.05,2.05-2.05-.92-2.05-2.05.92-2.05,2.05-2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-141",
    points: "275.56 603.82 278.51 606.77 282.54 605.69 283.62 601.66 280.67 598.71 276.64 599.79 275.56 603.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M278.15,601.29c.8-.8,2.1-.8,2.89,0s.8,2.1,0,2.89c-.8.8-2.1.8-2.89,0s-.8-2.1,0-2.89Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-141",
    points: "259.9 599.38 264.08 599.38 266.16 595.77 264.08 592.16 259.9 592.16 257.82 595.77 259.9 599.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M259.94,595.77c0-1.13.92-2.05,2.05-2.05s2.05.92,2.05,2.05-.92,2.05-2.05,2.05-2.05-.92-2.05-2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-141",
    points: "245.7 607.32 248.65 604.37 247.57 600.34 243.54 599.26 240.59 602.21 241.67 606.24 245.7 607.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M243.17,604.74c-.8-.8-.8-2.1,0-2.89.8-.8,2.1-.8,2.89,0s.8,2.1,0,2.89c-.8.8-2.1.8-2.89,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-141",
    points: "241.26 622.98 241.26 618.81 237.65 616.72 234.03 618.81 234.03 622.98 237.65 625.07 241.26 622.98"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-143",
    cx: 237.65,
    cy: 620.89,
    r: 2.05
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-141",
    points: "249.19 637.19 246.24 634.24 242.21 635.32 241.13 639.35 244.08 642.3 248.11 641.22 249.19 637.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M246.61,639.72c-.8.8-2.1.8-2.89,0s-.8-2.1,0-2.89c.8-.8,2.1-.8,2.89,0s.8,2.1,0,2.89Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-105",
    cx: 262.38,
    cy: 620.5,
    r: 13.3,
    transform: "translate(-401.81 733.3) rotate(-76.72)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-104",
    x: 812.32,
    y: 531.71,
    width: 211.04,
    height: 90.14,
    rx: 4.4,
    ry: 4.4,
    transform: "translate(1835.69 1153.57) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-127",
    x: 976.4,
    y: 607.97,
    width: 33.78,
    height: 20.53,
    transform: "translate(1986.58 1236.47) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-151",
    x: 988.29,
    y: 527.72,
    width: 9.99,
    height: 98.94,
    rx: 4,
    ry: 4,
    transform: "translate(1986.58 1154.37) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-141",
    d: "M993.29,626.65h0c1.77,0,3.2-1.43,3.2-3.2v-92.54c0-1.77-1.43-3.2-3.2-3.2h0c-1.77,0-3.2,1.43-3.2,3.2v92.54c0,1.77,1.43,3.2,3.2,3.2Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-128",
    x: 900.96,
    y: 607.97,
    width: 33.78,
    height: 20.53,
    transform: "translate(1835.69 1236.47) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-151",
    x: 912.85,
    y: 527.72,
    width: 9.99,
    height: 98.94,
    rx: 4,
    ry: 4,
    transform: "translate(1835.69 1154.37) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-141",
    d: "M917.84,626.65h0c1.77,0,3.2-1.43,3.2-3.2v-92.54c0-1.77-1.43-3.2-3.2-3.2h0c-1.77,0-3.2,1.43-3.2,3.2v92.54c0,1.77,1.43,3.2,3.2,3.2Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-121",
    x: 825.51,
    y: 607.97,
    width: 33.77,
    height: 20.53,
    transform: "translate(1684.8 1236.47) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-151",
    x: 837.4,
    y: 527.72,
    width: 9.99,
    height: 98.94,
    rx: 4,
    ry: 4,
    transform: "translate(1684.8 1154.37) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-141",
    d: "M842.4,626.65h0c1.77,0,3.2-1.43,3.2-3.2v-92.54c0-1.77-1.43-3.2-3.2-3.2h0c-1.77,0-3.2,1.43-3.2,3.2v92.54c0,1.77,1.43,3.2,3.2,3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M877.78,530.55h3.28c4.61,0,8.36,3.75,8.36,8.36v4.97h-20v-4.97c0-4.61,3.75-8.36,8.36-8.36Z",
    transform: "translate(1758.84 1074.42) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-142",
    d: "M869.42,530.55c0,3.86,4.48,6.99,10,6.99s10-3.13,10-6.99-4.48-6.99-10-6.99-10,3.13-10,6.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-163",
    d: "M870.82,529.19c0,3.11,3.85,5.63,8.59,5.63s8.59-2.52,8.59-5.63-3.85-5.63-8.59-5.63-8.59,2.52-8.59,5.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M249.69,312.65c1.74-2.14,2.66-4.94,2.3-7.88l-2.46-19.75c-.71-5.71-5.96-9.8-11.67-9.09l-.34.04c-5.71.71-9.8,5.96-9.09,11.67l2.46,19.75c.37,2.96,1.98,5.47,4.22,7.12-4.18,2.64-7.24,7.01-8,12.25l-8.48,58.55c-1.38,9.51,5.27,18.41,14.78,19.79,9.51,1.38,18.41-5.27,19.79-14.78l8.48-58.55c1.24-8.54-4.01-16.58-11.99-19.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M86.08,352.79c-.2,1.92,1.18,3.66,3.04,4.16l23.56,6.41-2.76,10.14c-.38,1.39-1.81,2.21-3.2,1.83h0c-.95-.26-1.92.3-2.18,1.25l-14.33,52.66,21.4,5.82,14.33-52.66c.26-.95-.3-1.92-1.25-2.18h0c-1.39-.38-2.21-1.81-1.83-3.2l2.76-10.14,23.56,6.41c1.86.51,3.93-.3,4.73-2.05,1.02-2.24-.23-4.75-2.5-5.36l-60.46-16.45c-2.27-.62-4.61.92-4.87,3.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M123.71,256.39h107.92c3.94,0,8.59,4.65,8.59,10.39v92.69c0,9.45-6.37,17.7-15.5,20.11l-127.56,33.59c-11.55,3.04-22.71-5.98-22.24-17.91,1.57-39.32,10.85-78.66,31.34-128.14,2.82-6.81,8.28-10.73,17.45-10.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-164",
    d: "M136.22,353.37l-5.79,8.81c-3.08,4.7-8.33,7.53-13.95,7.53h-39.42c-1.1,8.59-1.8,17.08-2.14,25.56-.47,11.93,10.7,20.94,22.24,17.9l127.56-33.59c9.13-2.4,15.5-10.66,15.5-20.11v-17.75h-82.45c-8.69,0-16.79,4.37-21.56,11.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-145",
    d: "M759.6,666.97c-6.08-2.73-23.11-5.04-24.13-26.15-.48-9.85-.67-45.37-.81-56.86h-3.32v57.23c0,11.72,1.6,14.72,6.78,23.52,3.47,5.88,10.51,9.59,17.74,6.9l3.55-1.32c1.69-.63,1.82-2.59.19-3.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-145",
    d: "M753.29,594.87l-5.55-10.65c-2.55-4.89-8.58-6.79-13.47-4.24h0c-4.89,2.55-6.79,8.59-4.24,13.48l3.27,6.27h-108.53v-.47h-17.75v.47h-108.53l3.27-6.27c2.55-4.89.65-10.92-4.24-13.48h0c-4.89-2.55-10.93-.65-13.48,4.24l-5.55,10.64c-2.55,4.89-.65,10.92,4.24,13.47h0c4.41,2.3,9.72.96,12.6-2.91h25.15v2.85h9.89v2.85h15.67v2.85h17.31v2.85h22.27v2.85h21.4v1.86h17.75v-1.86h21.4v-2.85h22.27v-2.85h17.32v-2.85h15.66v-2.85h9.89v-2.85h25.16c2.88,3.87,8.19,5.21,12.6,2.91h0c4.89-2.55,6.79-8.59,4.24-13.48Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-145",
    cx: 616.14,
    cy: 620.5,
    r: 39.87,
    transform: "translate(-192.92 952.28) rotate(-67.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M731.34,620.5h-11.99c0-57.04-46.41-103.45-103.45-103.45s-103.46,46.41-103.46,103.45h-11.99c0-63.66,51.79-115.44,115.45-115.44s115.45,51.79,115.45,115.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-142",
    d: "M725.1,620.5h-4.8c0-57.57-46.84-104.41-104.41-104.41s-104.41,46.84-104.41,104.41h-4.8c0-60.22,48.99-109.21,109.21-109.21s109.21,48.99,109.21,109.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-145",
    d: "M615.89,529.61c-50.2,0-90.9,40.7-90.9,90.9s40.7,90.9,90.9,90.9,90.9-40.7,90.9-90.9-40.7-90.9-90.9-90.9ZM615.89,667.6c-26.01,0-47.09-21.08-47.09-47.09s21.08-47.09,47.09-47.09,47.09,21.08,47.09,47.09-21.09,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M708.19,623.21v-4.71h-5.81c-.02-.95-.04-1.9-.09-2.84l5.78-.51-.41-4.7-5.76.5c-.1-.94-.22-1.88-.36-2.81l5.71-1.01-.82-4.64-5.68,1c-.19-.93-.4-1.85-.62-2.77l5.61-1.5-1.22-4.55-5.58,1.5c-.27-.91-.55-1.81-.84-2.71l5.45-1.98-1.61-4.43-5.43,1.98c-.34-.88-.69-1.76-1.06-2.63l5.24-2.44-1.99-4.27-5.24,2.44c-.42-.85-.85-1.69-1.29-2.53l5.01-2.89-2.36-4.08-5,2.88c-.49-.81-1.01-1.6-1.53-2.39l4.76-3.33-2.7-3.86-4.74,3.32c-.56-.76-1.14-1.51-1.73-2.25l4.46-3.74-3.03-3.61-4.44,3.73c-.62-.71-1.26-1.41-1.91-2.1l4.11-4.11-3.33-3.33-4.1,4.1c-.68-.65-1.37-1.3-2.08-1.93l3.73-4.45-3.61-3.03-3.73,4.44c-.74-.59-1.47-1.19-2.23-1.75l3.32-4.75-3.86-2.7-3.31,4.73c-.79-.52-1.58-1.03-2.39-1.53l2.9-5.02-4.08-2.36-2.88,5c-.83-.45-1.67-.88-2.52-1.31l2.45-5.26-4.27-1.99-2.44,5.24c-.87-.38-1.74-.74-2.62-1.09l1.98-5.45-4.43-1.61-1.98,5.43c-.9-.3-1.79-.6-2.7-.87l1.5-5.59-4.55-1.22-1.5,5.58c-.92-.22-1.84-.45-2.77-.64l1-5.7-4.64-.82-1,5.68c-.93-.14-1.87-.25-2.82-.36l.51-5.79-4.7-.41-.51,5.77c-.94-.06-1.89-.1-2.83-.13v-5.82h-4.71v5.81c-.95.02-1.9.04-2.84.09l-.51-5.78-4.7.41.5,5.76c-.94.1-1.88.22-2.81.36l-1.01-5.71-4.64.82,1,5.68c-.93.19-1.85.4-2.77.62l-1.5-5.61-4.55,1.22,1.5,5.58c-.91.27-1.81.55-2.71.84l-1.98-5.45-4.43,1.61,1.98,5.43c-.88.34-1.76.69-2.63,1.06l-2.44-5.24-4.27,1.99,2.44,5.24c-.85.42-1.69.85-2.53,1.29l-2.89-5.01-4.08,2.36,2.88,5c-.81.49-1.6,1.01-2.39,1.53l-3.33-4.76-3.86,2.7,3.32,4.74c-.76.56-1.51,1.14-2.25,1.73l-3.74-4.46-3.61,3.03,3.73,4.44c-.71.62-1.41,1.26-2.1,1.91l-4.11-4.11-3.33,3.33,4.1,4.1c-.65.68-1.3,1.37-1.93,2.08l-4.45-3.73-3.03,3.61,4.44,3.73c-.59.74-1.19,1.47-1.75,2.23l-4.75-3.32-2.7,3.86,4.73,3.31c-.52.79-1.03,1.59-1.53,2.39l-5.02-2.9-2.36,4.08,5,2.88c-.45.83-.88,1.67-1.31,2.52l-5.26-2.45-1.99,4.27,5.24,2.44c-.38.87-.74,1.74-1.09,2.62l-5.45-1.98-1.61,4.43,5.43,1.98c-.3.9-.6,1.79-.87,2.7l-5.59-1.5-1.22,4.55,5.58,1.5c-.22.92-.45,1.84-.64,2.77l-5.7-1-.82,4.64,5.68,1c-.14.93-.25,1.87-.36,2.82l-5.79-.51-.41,4.7,5.77.51c-.06.94-.1,1.89-.13,2.83h-5.82v4.71h5.8c.02.95.04,1.9.09,2.84l-5.78.51.41,4.7,5.76-.5c.1.94.22,1.88.36,2.82l-5.71,1.01.82,4.64,5.68-1c.19.93.4,1.85.62,2.77l-5.61,1.5,1.22,4.55,5.58-1.5c.27.91.55,1.81.84,2.71l-5.45,1.98,1.61,4.43,5.43-1.98c.34.88.69,1.76,1.06,2.63l-5.24,2.44,1.99,4.27,5.24-2.44c.42.85.85,1.69,1.29,2.53l-5.01,2.89,2.36,4.08,5-2.88c.49.81,1.01,1.6,1.53,2.39l-4.76,3.33,2.7,3.86,4.74-3.32c.56.76,1.14,1.51,1.73,2.25l-4.46,3.74,3.03,3.61,4.44-3.73c.62.71,1.26,1.41,1.91,2.1l-4.11,4.11,3.33,3.33,4.1-4.1c.68.65,1.37,1.3,2.08,1.93l-3.73,4.45,3.61,3.03,3.73-4.44c.74.59,1.47,1.19,2.23,1.75l-3.32,4.75,3.86,2.7,3.31-4.73c.79.52,1.58,1.03,2.39,1.53l-2.9,5.02,4.08,2.36,2.88-5c.83.45,1.67.88,2.52,1.31l-2.45,5.26,4.27,1.99,2.44-5.24c.87.38,1.74.74,2.62,1.09l-1.98,5.45,4.43,1.61,1.98-5.43c.9.3,1.79.6,2.7.87l-1.5,5.59,4.55,1.22,1.5-5.58c.92.22,1.84.45,2.77.64l-1,5.7,4.64.82,1-5.68c.93.14,1.87.25,2.82.36l-.51,5.79,4.7.41.51-5.77c.94.06,1.89.1,2.83.13v5.82h4.71v-5.81c.95-.02,1.9-.04,2.84-.09l.51,5.78,4.7-.41-.5-5.76c.94-.1,1.88-.22,2.82-.36l1.01,5.71,4.64-.82-1-5.68c.93-.19,1.85-.4,2.77-.62l1.5,5.61,4.55-1.22-1.5-5.58c.91-.27,1.81-.55,2.71-.84l1.98,5.45,4.43-1.61-1.98-5.43c.88-.34,1.76-.69,2.63-1.06l2.44,5.24,4.27-1.99-2.44-5.24c.85-.42,1.69-.85,2.53-1.29l2.89,5.01,4.08-2.36-2.88-5c.81-.49,1.6-1.01,2.39-1.53l3.33,4.76,3.86-2.7-3.32-4.74c.76-.56,1.51-1.14,2.25-1.73l3.74,4.46,3.61-3.03-3.73-4.44c.71-.62,1.41-1.26,2.1-1.91l4.11,4.11,3.33-3.33-4.1-4.1c.65-.68,1.3-1.37,1.93-2.08l4.45,3.73,3.03-3.61-4.44-3.73c.59-.74,1.19-1.47,1.75-2.23l4.75,3.32,2.7-3.86-4.73-3.31c.52-.79,1.03-1.59,1.53-2.39l5.02,2.9,2.36-4.08-5-2.88c.45-.83.88-1.67,1.31-2.52l5.26,2.45,1.99-4.27-5.23-2.44c.38-.87.74-1.74,1.09-2.62l5.45,1.98,1.61-4.43-5.43-1.98c.3-.9.6-1.79.87-2.7l5.59,1.5,1.22-4.55-5.58-1.5c.22-.92.45-1.84.64-2.77l5.7,1,.82-4.64-5.68-1c.14-.93.25-1.87.36-2.82l5.79.51.41-4.7-5.77-.51c.06-.94.1-1.89.13-2.83h5.82ZM615.89,667.6c-26.01,0-47.09-21.08-47.09-47.09s21.08-47.09,47.09-47.09,47.09,21.08,47.09,47.09-21.09,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M615.89,538.14c-45.49,0-82.37,36.88-82.37,82.37s36.88,82.37,82.37,82.37,82.37-36.88,82.37-82.37-36.88-82.37-82.37-82.37ZM615.89,667.6c-26.01,0-47.09-21.08-47.09-47.09s21.08-47.09,47.09-47.09,47.09,21.08,47.09,47.09-21.09,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "M665.77,628.74c-1.08,1.93-2.53,3.14-4.13,3.14-3.34,0-6.05-5.16-6.05-11.52s2.71-11.52,6.05-11.52c1.57,0,2.99,1.17,4.07,3.04-1.32-7.68-4.36-14.76-8.73-20.84.61,2.14.44,4.02-.7,5.16-2.36,2.36-7.93.64-12.43-3.86-4.5-4.5-6.23-10.06-3.86-12.43,1.12-1.12,2.96-1.29,5.06-.72-6.11-4.32-13.22-7.3-20.92-8.56,1.93,1.08,3.13,2.53,3.13,4.13,0,3.34-5.16,6.05-11.52,6.05s-11.52-2.71-11.52-6.05c0-1.57,1.17-2.99,3.04-4.07-7.68,1.32-14.76,4.36-20.84,8.73,2.14-.61,4.02-.44,5.16.7,2.36,2.36.63,7.93-3.86,12.43-4.5,4.5-10.06,6.23-12.43,3.86-1.12-1.12-1.29-2.96-.72-5.06-4.32,6.11-7.3,13.22-8.56,20.92,1.08-1.93,2.53-3.14,4.13-3.14,3.34,0,6.06,5.16,6.06,11.52s-2.71,11.52-6.06,11.52c-1.57,0-2.99-1.17-4.07-3.04,1.32,7.68,4.36,14.76,8.73,20.84-.61-2.14-.44-4.02.7-5.16,2.37-2.36,7.93-.64,12.43,3.86,4.5,4.5,6.23,10.06,3.86,12.43-1.12,1.12-2.96,1.29-5.06.72,6.11,4.32,13.22,7.3,20.92,8.56-1.93-1.08-3.14-2.53-3.14-4.13,0-3.34,5.16-6.05,11.52-6.05s11.52,2.71,11.52,6.05c0,1.57-1.17,2.99-3.04,4.07,7.68-1.32,14.76-4.36,20.84-8.73-2.14.61-4.02.44-5.16-.7-2.36-2.37-.63-7.93,3.86-12.43,4.5-4.5,10.06-6.23,12.43-3.86,1.12,1.12,1.29,2.96.72,5.06,4.32-6.11,7.3-13.22,8.56-20.92Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-125",
    cx: 615.89,
    cy: 620.5,
    r: 31.07,
    transform: "translate(-258.37 617.24) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-149",
    d: "M615.89,569.85c-27.98,0-50.66,22.68-50.66,50.66s22.68,50.66,50.66,50.66,50.66-22.68,50.66-50.66-22.68-50.66-50.66-50.66ZM615.89,668.11c-26.29,0-47.61-21.31-47.61-47.61s21.31-47.61,47.61-47.61,47.61,21.31,47.61,47.61-21.31,47.61-47.61,47.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-126",
    d: "M615.89,563.02c-31.75,0-57.48,25.74-57.48,57.48s25.74,57.48,57.48,57.48,57.48-25.74,57.48-57.48-25.74-57.48-57.48-57.48ZM615.89,670.39c-27.55,0-49.88-22.33-49.88-49.88s22.33-49.88,49.88-49.88,49.88,22.33,49.88,49.88-22.33,49.88-49.88,49.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M665.77,628.74c-1.08,1.93-2.53,3.14-4.13,3.14-3.34,0-6.05-5.16-6.05-11.52s2.71-11.52,6.05-11.52c1.57,0,2.99,1.17,4.07,3.04-1.32-7.68-4.36-14.76-8.73-20.84.61,2.14.44,4.02-.7,5.16-2.36,2.36-7.93.64-12.43-3.86-4.5-4.5-6.23-10.06-3.86-12.43,1.12-1.12,2.96-1.29,5.06-.72-6.11-4.32-13.22-7.3-20.92-8.56,1.93,1.08,3.13,2.53,3.13,4.13,0,3.34-5.16,6.05-11.52,6.05s-11.52-2.71-11.52-6.05c0-1.57,1.17-2.99,3.04-4.07-7.68,1.32-14.76,4.36-20.84,8.73,2.14-.61,4.02-.44,5.16.7,2.36,2.36.63,7.93-3.86,12.43-4.5,4.5-10.06,6.23-12.43,3.86-1.12-1.12-1.29-2.96-.72-5.06-4.32,6.11-7.3,13.22-8.56,20.92,1.08-1.93,2.53-3.14,4.13-3.14,3.34,0,6.06,5.16,6.06,11.52s-2.71,11.52-6.06,11.52c-1.57,0-2.99-1.17-4.07-3.04,1.32,7.68,4.36,14.76,8.73,20.84-.61-2.14-.44-4.02.7-5.16,2.37-2.36,7.93-.64,12.43,3.86,4.5,4.5,6.23,10.06,3.86,12.43-1.12,1.12-2.96,1.29-5.06.72,6.11,4.32,13.22,7.3,20.92,8.56-1.93-1.08-3.14-2.53-3.14-4.13,0-3.34,5.16-6.05,11.52-6.05s11.52,2.71,11.52,6.05c0,1.57-1.17,2.99-3.04,4.07,7.68-1.32,14.76-4.36,20.84-8.73-2.14.61-4.02.44-5.16-.7-2.36-2.37-.63-7.93,3.86-12.43,4.5-4.5,10.06-6.23,12.43-3.86,1.12,1.12,1.29,2.96.72,5.06,4.32-6.11,7.3-13.22,8.56-20.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-140",
    d: "M615.89,568.42c-28.77,0-52.09,23.32-52.09,52.09s23.32,52.09,52.09,52.09,52.09-23.32,52.09-52.09-23.32-52.09-52.09-52.09ZM615.89,669.46c-27.04,0-48.95-21.92-48.95-48.95s21.92-48.95,48.95-48.95,48.95,21.92,48.95,48.95-21.92,48.95-48.95,48.95Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-124",
    cx: 615.89,
    cy: 620.5,
    r: 18.8,
    transform: "translate(-258.37 617.24) rotate(-45)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-141",
    points: "618.36 641.63 614.19 641.63 612.11 645.24 614.19 648.85 618.36 648.85 620.45 645.24 618.36 641.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M618.32,645.24c0,1.13-.92,2.05-2.05,2.05s-2.05-.92-2.05-2.05.92-2.05,2.05-2.05,2.05.92,2.05,2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-141",
    points: "632.57 633.69 629.62 636.64 630.7 640.67 634.73 641.75 637.68 638.8 636.6 634.77 632.57 633.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M635.1,636.27c.8.8.8,2.09,0,2.89s-2.1.8-2.89,0c-.8-.8-.8-2.1,0-2.89.8-.8,2.1-.8,2.89,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-141",
    points: "637.01 618.03 637.01 622.2 640.62 624.29 644.24 622.2 644.24 618.03 640.62 615.94 637.01 618.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M640.62,618.07c1.13,0,2.05.92,2.05,2.05s-.92,2.05-2.05,2.05-2.05-.92-2.05-2.05.92-2.05,2.05-2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-141",
    points: "629.07 603.82 632.02 606.77 636.05 605.69 637.13 601.66 634.18 598.71 630.15 599.79 629.07 603.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M631.66,601.29c.8-.8,2.1-.8,2.89,0,.8.8.8,2.1,0,2.89-.8.8-2.1.8-2.89,0-.8-.8-.8-2.1,0-2.89Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-141",
    points: "613.42 599.38 617.59 599.38 619.67 595.77 617.59 592.16 613.42 592.16 611.33 595.77 613.42 599.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M613.45,595.77c0-1.13.92-2.05,2.05-2.05s2.05.92,2.05,2.05-.92,2.05-2.05,2.05-2.05-.92-2.05-2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-141",
    points: "599.21 607.32 602.16 604.37 601.08 600.34 597.05 599.26 594.1 602.21 595.18 606.24 599.21 607.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M596.68,604.74c-.8-.8-.8-2.1,0-2.89s2.1-.8,2.89,0c.8.8.8,2.1,0,2.89-.8.8-2.1.8-2.89,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-141",
    points: "594.77 622.98 594.77 618.81 591.16 616.72 587.54 618.81 587.54 622.98 591.16 625.07 594.77 622.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M591.16,622.94c-1.13,0-2.05-.92-2.05-2.05s.92-2.05,2.05-2.05,2.05.92,2.05,2.05-.92,2.05-2.05,2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-141",
    points: "602.71 637.19 599.76 634.24 595.73 635.32 594.65 639.35 597.6 642.3 601.63 641.22 602.71 637.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M600.12,639.72c-.8.8-2.09.8-2.89,0-.8-.8-.8-2.1,0-2.89s2.1-.8,2.89,0c.8.8.8,2.1,0,2.89Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-123",
    cx: 615.89,
    cy: 620.5,
    r: 13.3,
    transform: "translate(-258.37 617.24) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-145",
    d: "M1435.26,594.87l-5.55-10.65c-2.55-4.89-8.58-6.79-13.47-4.24h0c-4.89,2.55-6.79,8.59-4.24,13.48l3.27,6.27h-108.53v-.47h-17.75v.47h-108.53l3.27-6.27c2.55-4.89.65-10.92-4.24-13.48h0c-4.89-2.55-10.93-.65-13.48,4.24l-5.55,10.64c-2.55,4.89-.65,10.92,4.24,13.47h0c4.41,2.3,9.72.96,12.6-2.91h25.15v2.85h9.89v2.85h15.67v2.85h17.31v2.85h22.27v2.85h21.4v1.86h17.75v-1.86h21.4v-2.85h22.27v-2.85h17.32v-2.85h15.66v-2.85h9.89v-2.85h25.16c2.88,3.87,8.19,5.21,12.6,2.91h0c4.89-2.55,6.79-8.59,4.24-13.48Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-145",
    cx: 1298.1,
    cy: 620.5,
    r: 39.87,
    transform: "translate(228.07 1582.34) rotate(-67.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-145",
    d: "M1671.72,594.87l-5.55-10.65c-2.55-4.89-8.58-6.79-13.47-4.24h0c-4.89,2.55-6.79,8.59-4.24,13.48l3.27,6.27h-108.53v-.47h-17.75v.47h-108.53l3.27-6.27c2.55-4.89.65-10.92-4.24-13.48h0c-4.89-2.55-10.93-.65-13.48,4.24l-5.55,10.64c-2.55,4.89-.65,10.92,4.24,13.47h0c4.41,2.3,9.72.96,12.6-2.91h25.15v2.85h9.89v2.85h15.67v2.85h17.31v2.85h22.27v2.85h21.4v1.86h17.75v-1.86h21.4v-2.85h22.27v-2.85h17.32v-2.85h15.66v-2.85h9.89v-2.85h25.16c2.88,3.87,8.19,5.21,12.6,2.91h0c4.89-2.55,6.79-8.59,4.24-13.48Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-145",
    cx: 1534.56,
    cy: 620.5,
    r: 39.87,
    transform: "translate(374.04 1800.8) rotate(-67.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-133",
    x: 1383.64,
    y: 546.32,
    width: 65.43,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-130",
    x: 1375.74,
    y: 552.12,
    width: 81.24,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-131",
    x: 1367.83,
    y: 557.92,
    width: 97.06,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-132",
    x: 1359.92,
    y: 563.71,
    width: 112.87,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-136",
    x: 1352.01,
    y: 569.51,
    width: 128.68,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-137",
    x: 1344.11,
    y: 575.31,
    width: 144.5,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-134",
    x: 1336.2,
    y: 581.11,
    width: 160.31,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-135",
    x: 1328.29,
    y: 586.91,
    width: 176.12,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-129",
    x: 1320.39,
    y: 592.7,
    width: 191.94,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-138",
    x: 1312.48,
    y: 598.5,
    width: 207.75,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 1304.57,
    y: 604.3,
    width: 223.57,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 1296.67,
    y: 610.1,
    width: 239.38,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 1392.82,
    y: 545.07,
    width: 7.19,
    height: 72.08
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 1432.69,
    y: 545.07,
    width: 7.19,
    height: 72.08
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-145",
    d: "M1397.53,609.89l7.54,34.13c.42,1.9,1.44,3.14,2.58,3.14h17.42c1.14,0,2.16-1.25,2.58-3.14l7.54-34.13c.72-3.26-.62-6.8-2.58-6.8h-32.49c-1.96,0-3.3,3.54-2.58,6.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-145",
    d: "M1397.65,629.33c-4.44.38-8.02,3.25-9.6,7.11l-100.9,8.57.88,10.36,100.9-8.57c2.21,3.53,6.23,5.77,10.66,5.39,6.31-.54,10.99-6.09,10.46-12.4-.54-6.31-6.09-10.99-12.4-10.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-145",
    d: "M1435.06,629.33c4.44.38,8.02,3.25,9.6,7.11l100.9,8.57-.88,10.36-100.9-8.57c-2.21,3.53-6.23,5.77-10.66,5.39-6.31-.54-10.99-6.09-10.46-12.4s6.09-10.99,12.4-10.46Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-145",
    cx: 1298.1,
    cy: 620.5,
    r: 39.87,
    transform: "translate(228.07 1582.34) rotate(-67.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-145",
    d: "M1297.86,529.61c-50.2,0-90.9,40.7-90.9,90.9s40.7,90.9,90.9,90.9,90.9-40.7,90.9-90.9-40.7-90.9-90.9-90.9ZM1297.86,667.6c-26.01,0-47.09-21.08-47.09-47.09s21.08-47.09,47.09-47.09,47.09,21.08,47.09,47.09-21.08,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1390.15,623.21v-4.71h-5.8c-.02-.95-.04-1.9-.09-2.84l5.78-.51-.41-4.7-5.76.5c-.1-.94-.22-1.88-.36-2.81l5.71-1.01-.82-4.64-5.68,1c-.19-.93-.4-1.85-.62-2.77l5.61-1.5-1.22-4.55-5.58,1.5c-.27-.91-.55-1.81-.84-2.71l5.45-1.98-1.61-4.43-5.43,1.98c-.34-.88-.69-1.76-1.06-2.63l5.24-2.44-1.99-4.27-5.24,2.44c-.42-.85-.85-1.69-1.29-2.53l5.01-2.89-2.36-4.08-5,2.88c-.49-.81-1.01-1.6-1.53-2.39l4.76-3.33-2.7-3.86-4.74,3.32c-.56-.76-1.14-1.51-1.73-2.25l4.46-3.74-3.03-3.61-4.44,3.73c-.62-.71-1.26-1.41-1.91-2.1l4.11-4.11-3.33-3.33-4.1,4.1c-.68-.65-1.37-1.3-2.08-1.93l3.73-4.45-3.61-3.03-3.73,4.44c-.74-.59-1.47-1.19-2.23-1.75l3.32-4.75-3.86-2.7-3.31,4.73c-.79-.52-1.58-1.03-2.39-1.53l2.9-5.02-4.08-2.36-2.88,5c-.83-.45-1.67-.88-2.52-1.31l2.45-5.26-4.27-1.99-2.44,5.24c-.87-.38-1.74-.74-2.62-1.09l1.98-5.45-4.43-1.61-1.98,5.43c-.9-.3-1.79-.6-2.7-.87l1.5-5.59-4.55-1.22-1.5,5.58c-.92-.22-1.84-.45-2.77-.64l1-5.7-4.64-.82-1,5.68c-.93-.14-1.87-.25-2.82-.36l.51-5.79-4.7-.41-.51,5.77c-.94-.06-1.89-.1-2.83-.13v-5.82h-4.71v5.81c-.95.02-1.9.04-2.84.09l-.51-5.78-4.7.41.5,5.76c-.94.1-1.88.22-2.82.36l-1.01-5.71-4.64.82,1,5.68c-.93.19-1.85.4-2.77.62l-1.5-5.61-4.55,1.22,1.5,5.58c-.91.27-1.81.55-2.71.84l-1.98-5.45-4.43,1.61,1.98,5.43c-.88.34-1.76.69-2.63,1.06l-2.44-5.24-4.27,1.99,2.44,5.24c-.85.42-1.69.85-2.53,1.29l-2.89-5.01-4.08,2.36,2.88,5c-.81.49-1.6,1.01-2.39,1.53l-3.33-4.76-3.86,2.7,3.32,4.74c-.76.56-1.51,1.14-2.25,1.73l-3.74-4.46-3.61,3.03,3.73,4.44c-.71.62-1.41,1.26-2.1,1.91l-4.11-4.11-3.33,3.33,4.1,4.1c-.65.68-1.3,1.37-1.93,2.08l-4.45-3.73-3.03,3.61,4.44,3.73c-.59.74-1.19,1.47-1.75,2.23l-4.75-3.32-2.7,3.86,4.73,3.31c-.52.79-1.03,1.59-1.53,2.39l-5.02-2.9-2.36,4.08,5,2.88c-.45.83-.88,1.67-1.31,2.52l-5.26-2.45-1.99,4.27,5.24,2.44c-.38.87-.74,1.74-1.09,2.62l-5.45-1.98-1.61,4.43,5.43,1.98c-.3.9-.6,1.79-.87,2.7l-5.59-1.5-1.22,4.55,5.58,1.5c-.22.92-.45,1.84-.64,2.77l-5.7-1-.82,4.64,5.68,1c-.14.93-.25,1.87-.36,2.82l-5.79-.51-.41,4.7,5.77.51c-.06.94-.1,1.89-.13,2.83h-5.82v4.71h5.8c.02.95.04,1.9.09,2.84l-5.78.51.41,4.7,5.76-.5c.1.94.22,1.88.36,2.82l-5.71,1.01.82,4.64,5.68-1c.19.93.4,1.85.62,2.77l-5.61,1.5,1.22,4.55,5.58-1.5c.27.91.55,1.81.84,2.71l-5.45,1.98,1.61,4.43,5.43-1.98c.34.88.69,1.76,1.06,2.63l-5.24,2.44,1.99,4.27,5.24-2.44c.42.85.85,1.69,1.29,2.53l-5.01,2.89,2.36,4.08,5-2.88c.49.81,1.01,1.6,1.53,2.39l-4.76,3.33,2.7,3.86,4.74-3.32c.56.76,1.14,1.51,1.73,2.25l-4.46,3.74,3.03,3.61,4.44-3.73c.62.71,1.26,1.41,1.91,2.1l-4.11,4.11,3.33,3.33,4.1-4.1c.68.65,1.37,1.3,2.08,1.93l-3.73,4.45,3.61,3.03,3.73-4.44c.74.59,1.47,1.19,2.23,1.75l-3.32,4.75,3.86,2.7,3.31-4.73c.79.52,1.58,1.03,2.39,1.53l-2.9,5.02,4.08,2.36,2.88-5c.83.45,1.67.88,2.52,1.31l-2.45,5.26,4.27,1.99,2.44-5.24c.87.38,1.74.74,2.62,1.09l-1.98,5.45,4.43,1.61,1.98-5.43c.9.3,1.79.6,2.7.87l-1.5,5.59,4.55,1.22,1.5-5.58c.92.22,1.84.45,2.77.64l-1,5.7,4.64.82,1-5.68c.93.14,1.87.25,2.82.36l-.51,5.79,4.7.41.5-5.77c.94.06,1.89.1,2.83.13v5.82h4.71v-5.81c.95-.02,1.9-.04,2.84-.09l.51,5.78,4.7-.41-.5-5.76c.94-.1,1.88-.22,2.82-.36l1.01,5.71,4.64-.82-1-5.68c.93-.19,1.85-.4,2.77-.62l1.5,5.61,4.55-1.22-1.5-5.58c.91-.27,1.81-.55,2.71-.84l1.98,5.45,4.43-1.61-1.98-5.43c.88-.34,1.76-.69,2.63-1.06l2.44,5.24,4.27-1.99-2.44-5.24c.85-.42,1.69-.85,2.53-1.29l2.89,5.01,4.08-2.36-2.88-5c.81-.49,1.6-1.01,2.39-1.53l3.33,4.76,3.86-2.7-3.32-4.74c.76-.56,1.51-1.14,2.25-1.73l3.74,4.46,3.61-3.03-3.73-4.44c.71-.62,1.41-1.26,2.1-1.91l4.11,4.11,3.33-3.33-4.1-4.1c.65-.68,1.3-1.37,1.93-2.08l4.45,3.73,3.03-3.61-4.44-3.73c.59-.74,1.19-1.47,1.75-2.23l4.75,3.32,2.7-3.86-4.73-3.31c.52-.79,1.03-1.59,1.53-2.39l5.02,2.9,2.36-4.08-5-2.88c.45-.83.88-1.67,1.31-2.52l5.26,2.45,1.99-4.27-5.23-2.44c.38-.87.74-1.74,1.09-2.62l5.45,1.98,1.61-4.43-5.43-1.98c.3-.9.6-1.79.87-2.7l5.59,1.5,1.22-4.55-5.58-1.5c.22-.92.45-1.84.64-2.77l5.7,1,.82-4.64-5.68-1c.14-.93.25-1.87.36-2.82l5.79.51.41-4.7-5.77-.51c.06-.94.1-1.89.13-2.83h5.82ZM1297.86,667.6c-26.01,0-47.09-21.08-47.09-47.09s21.08-47.09,47.09-47.09,47.09,21.08,47.09,47.09-21.08,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1297.86,538.14c-45.49,0-82.37,36.88-82.37,82.37s36.88,82.37,82.37,82.37,82.37-36.88,82.37-82.37-36.88-82.37-82.37-82.37ZM1297.86,667.6c-26.01,0-47.09-21.08-47.09-47.09s21.08-47.09,47.09-47.09,47.09,21.08,47.09,47.09-21.08,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M1297.86,563.02c-31.75,0-57.48,25.74-57.48,57.48s25.74,57.48,57.48,57.48,57.48-25.74,57.48-57.48-25.74-57.48-57.48-57.48ZM1297.86,670.39c-27.55,0-49.88-22.33-49.88-49.88s22.33-49.88,49.88-49.88,49.88,22.33,49.88,49.88-22.33,49.88-49.88,49.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-140",
    d: "M1297.86,568.42c-28.77,0-52.09,23.32-52.09,52.09s23.32,52.09,52.09,52.09,52.09-23.32,52.09-52.09-23.32-52.09-52.09-52.09ZM1297.86,668.6c-26.56,0-48.1-21.53-48.1-48.1s21.53-48.1,48.1-48.1,48.1,21.53,48.1,48.1-21.53,48.1-48.1,48.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M1297.83,570.02c-27.9,0-50.52,22.62-50.52,50.52s22.62,50.52,50.52,50.52,50.52-22.62,50.52-50.52-22.62-50.52-50.52-50.52ZM1265.06,587.95c4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08-4.01,4.01-8.97,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08ZM1257.02,630.94c-2.98,0-5.4-4.6-5.4-10.27s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27-2.42,10.27-5.4,10.27ZM1276.33,656.75c-2.11,2.11-7.07.57-11.09-3.45-4.01-4.01-5.56-8.97-3.45-11.08,2.11-2.11,7.07-.57,11.08,3.45s5.56,8.98,3.45,11.09ZM1297.7,574.33c5.68,0,10.27,2.42,10.27,5.4s-4.6,5.4-10.27,5.4-10.27-2.42-10.27-5.4,4.6-5.4,10.27-5.4ZM1297.96,666.75c-5.67,0-10.28-2.42-10.28-5.4s4.6-5.4,10.28-5.4,10.27,2.42,10.27,5.4-4.6,5.4-10.27,5.4ZM1319.33,584.32c2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.97-3.45-11.08ZM1330.59,653.12c-4.01,4.01-8.98,5.56-11.08,3.45s-.57-7.07,3.45-11.08c4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08ZM1338.64,630.68c-2.98,0-5.4-4.6-5.4-10.28s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27-2.42,10.28-5.4,10.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-166",
    d: "M1347.86,613.93c-3.24-24.77-24.38-43.92-50.04-43.92s-46.79,19.14-50.04,43.91c1.02,3.42,2.38,6.7,4.1,9.78-.16-.97-.27-1.98-.27-3.05,0-5.68,2.42-10.27,5.4-10.27s5.4,4.6,5.4,10.27-2.42,10.27-5.4,10.27c-.08,0-.15-.04-.22-.04,9.53,11.72,24.35,19.29,41.03,19.29s31.75-7.7,41.27-19.59c-.15.03-.3.09-.46.09-2.98,0-5.4-4.6-5.4-10.27s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27c0,1.21-.13,2.36-.33,3.44,1.75-3.12,3.13-6.44,4.16-9.91ZM1272.7,595.59c-4.01,4.01-8.98,5.56-11.08,3.45s-.57-7.07,3.45-11.08c4.01-4.01,8.98-5.56,11.08-3.45s.57,7.07-3.45,11.08ZM1297.7,585.13c-5.67,0-10.27-2.42-10.27-5.4s4.6-5.4,10.27-5.4,10.27,2.42,10.27,5.4-4.6,5.4-10.27,5.4ZM1333.86,598.85c-2.11,2.11-7.07.57-11.09-3.45-4.01-4.01-5.56-8.97-3.45-11.08,2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-151",
    d: "M1262.65,599.69c-.39-.15-.75-.36-1.04-.65-2.11-2.11-.57-7.07,3.45-11.08s8.98-5.56,11.08-3.45c1.71,1.71.99,5.29-1.47,8.72,7.16-2.89,14.98-4.49,23.18-4.49s15.9,1.58,23.02,4.43c-2.53-3.47-3.28-7.11-1.55-8.84,2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09-.29.3-.66.5-1.05.66,5.79,3.96,10.87,8.87,15.03,14.51,0-.03.02-.06.03-.08-3.24-24.77-24.38-43.92-50.04-43.92s-46.79,19.14-50.04,43.91c.01.05.04.09.05.14,4.1-5.58,9.11-10.45,14.81-14.39ZM1297.7,574.33c5.68,0,10.27,2.42,10.27,5.4s-4.6,5.4-10.27,5.4-10.27-2.42-10.27-5.4,4.6-5.4,10.27-5.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M1297.83,570.02c-27.9,0-50.52,22.62-50.52,50.52s22.62,50.52,50.52,50.52,50.52-22.62,50.52-50.52-22.62-50.52-50.52-50.52ZM1265.06,587.95c4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08-4.01,4.01-8.97,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08ZM1257.02,630.94c-2.98,0-5.4-4.6-5.4-10.27s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27-2.42,10.27-5.4,10.27ZM1276.33,656.75c-2.11,2.11-7.07.57-11.09-3.45-4.01-4.01-5.56-8.97-3.45-11.08,2.11-2.11,7.07-.57,11.08,3.45s5.56,8.98,3.45,11.09ZM1297.7,574.33c5.68,0,10.27,2.42,10.27,5.4s-4.6,5.4-10.27,5.4-10.27-2.42-10.27-5.4,4.6-5.4,10.27-5.4ZM1297.96,666.75c-5.67,0-10.28-2.42-10.28-5.4s4.6-5.4,10.28-5.4,10.27,2.42,10.27,5.4-4.6,5.4-10.27,5.4ZM1319.33,584.32c2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.97-3.45-11.08ZM1330.59,653.12c-4.01,4.01-8.98,5.56-11.08,3.45s-.57-7.07,3.45-11.08c4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08ZM1338.64,630.68c-2.98,0-5.4-4.6-5.4-10.28s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27-2.42,10.28-5.4,10.28Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-145",
    points: "1300.33 641.63 1296.16 641.63 1294.07 645.24 1296.16 648.85 1300.33 648.85 1302.42 645.24 1300.33 641.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M1300.29,645.24c0,1.13-.92,2.05-2.05,2.05s-2.05-.92-2.05-2.05.92-2.05,2.05-2.05,2.05.92,2.05,2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-145",
    points: "1314.54 633.69 1311.59 636.64 1312.67 640.67 1316.7 641.75 1319.65 638.8 1318.57 634.77 1314.54 633.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M1317.07,636.27c.8.8.8,2.09,0,2.89s-2.09.8-2.89,0c-.8-.8-.8-2.1,0-2.89s2.1-.8,2.89,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-145",
    points: "1318.98 618.03 1318.98 622.2 1322.59 624.29 1326.2 622.2 1326.2 618.03 1322.59 615.94 1318.98 618.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M1322.59,618.07c1.13,0,2.05.92,2.05,2.05s-.92,2.05-2.05,2.05-2.05-.92-2.05-2.05.92-2.05,2.05-2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-145",
    points: "1311.04 603.82 1313.99 606.77 1318.02 605.69 1319.1 601.66 1316.15 598.71 1312.12 599.79 1311.04 603.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M1313.62,601.29c.8-.8,2.1-.8,2.89,0s.8,2.1,0,2.89c-.8.8-2.1.8-2.89,0-.8-.8-.8-2.1,0-2.89Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-145",
    points: "1295.38 599.38 1299.55 599.38 1301.64 595.77 1299.55 592.16 1295.38 592.16 1293.3 595.77 1295.38 599.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M1295.42,595.77c0-1.13.92-2.05,2.05-2.05s2.05.92,2.05,2.05-.92,2.05-2.05,2.05-2.05-.92-2.05-2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-145",
    points: "1281.17 607.32 1284.12 604.37 1283.04 600.34 1279.01 599.26 1276.06 602.21 1277.14 606.24 1281.17 607.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M1278.65,604.74c-.8-.8-.8-2.1,0-2.89s2.1-.8,2.89,0,.8,2.1,0,2.89c-.8.8-2.1.8-2.89,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-145",
    points: "1276.74 622.98 1276.74 618.81 1273.12 616.72 1269.51 618.81 1269.51 622.98 1273.12 625.07 1276.74 622.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M1273.12,622.94c-1.13,0-2.05-.92-2.05-2.05s.92-2.05,2.05-2.05,2.05.92,2.05,2.05-.92,2.05-2.05,2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-145",
    points: "1284.67 637.19 1281.72 634.24 1277.69 635.32 1276.61 639.35 1279.56 642.3 1283.59 641.22 1284.67 637.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M1282.09,639.72c-.8.8-2.09.8-2.89,0-.8-.8-.8-2.1,0-2.89s2.1-.8,2.89,0c.8.8.8,2.1,0,2.89Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-27",
    cx: 1297.86,
    cy: 620.5,
    r: 18.8,
    transform: "translate(477.47 1802.21) rotate(-80.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M1311.04,620.5c0,7.28-5.9,13.18-13.18,13.18s-13.18-5.9-13.18-13.18,5.9-13.18,13.18-13.18,13.18,5.9,13.18,13.18Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-145",
    cx: 1534.8,
    cy: 620.5,
    r: 39.87,
    transform: "translate(496.16 1909.64) rotate(-73.15)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-145",
    d: "M1534.55,529.61c-50.2,0-90.9,40.7-90.9,90.9s40.7,90.9,90.9,90.9,90.9-40.7,90.9-90.9-40.7-90.9-90.9-90.9ZM1534.55,667.6c-26.01,0-47.09-21.08-47.09-47.09s21.08-47.09,47.09-47.09,47.09,21.08,47.09,47.09-21.09,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1626.85,623.21v-4.71h-5.81c-.02-.95-.04-1.9-.09-2.84l5.78-.51-.41-4.7-5.76.5c-.1-.94-.22-1.88-.36-2.81l5.71-1.01-.82-4.64-5.68,1c-.19-.93-.4-1.85-.62-2.77l5.61-1.5-1.22-4.55-5.58,1.5c-.27-.91-.55-1.81-.84-2.71l5.45-1.98-1.61-4.43-5.43,1.98c-.34-.88-.69-1.76-1.06-2.63l5.24-2.44-1.99-4.27-5.24,2.44c-.42-.85-.85-1.69-1.29-2.53l5.01-2.89-2.36-4.08-5,2.88c-.49-.81-1.01-1.6-1.53-2.39l4.76-3.33-2.7-3.86-4.74,3.32c-.56-.76-1.14-1.51-1.73-2.25l4.46-3.74-3.03-3.61-4.44,3.73c-.62-.71-1.26-1.41-1.91-2.1l4.11-4.11-3.33-3.33-4.1,4.1c-.68-.65-1.37-1.3-2.08-1.93l3.73-4.45-3.61-3.03-3.73,4.44c-.74-.59-1.47-1.19-2.23-1.75l3.32-4.75-3.86-2.7-3.31,4.73c-.79-.52-1.58-1.03-2.39-1.53l2.9-5.02-4.08-2.36-2.88,5c-.83-.45-1.67-.88-2.52-1.31l2.45-5.26-4.27-1.99-2.44,5.24c-.86-.38-1.74-.74-2.62-1.09l1.98-5.45-4.43-1.61-1.98,5.43c-.9-.3-1.79-.6-2.7-.87l1.5-5.59-4.55-1.22-1.5,5.58c-.92-.22-1.84-.45-2.77-.64l1-5.7-4.64-.82-1,5.68c-.93-.14-1.87-.25-2.82-.36l.51-5.79-4.7-.41-.51,5.77c-.94-.06-1.89-.1-2.83-.13v-5.82h-4.71v5.81c-.95.02-1.9.04-2.84.09l-.51-5.78-4.7.41.5,5.76c-.94.1-1.88.22-2.81.36l-1.01-5.71-4.64.82,1,5.68c-.93.19-1.85.4-2.77.62l-1.5-5.61-4.55,1.22,1.5,5.58c-.91.27-1.81.55-2.71.84l-1.98-5.45-4.43,1.61,1.98,5.43c-.88.34-1.76.69-2.63,1.06l-2.44-5.24-4.27,1.99,2.44,5.24c-.85.42-1.69.85-2.53,1.29l-2.89-5.01-4.08,2.36,2.88,5c-.81.49-1.6,1.01-2.39,1.53l-3.33-4.76-3.86,2.7,3.32,4.74c-.76.56-1.51,1.14-2.25,1.73l-3.74-4.46-3.61,3.03,3.73,4.44c-.71.62-1.41,1.26-2.1,1.91l-4.11-4.11-3.33,3.33,4.1,4.1c-.65.68-1.3,1.37-1.93,2.08l-4.45-3.73-3.03,3.61,4.44,3.73c-.59.74-1.19,1.47-1.75,2.23l-4.75-3.32-2.7,3.86,4.73,3.31c-.52.79-1.03,1.59-1.53,2.39l-5.02-2.9-2.36,4.08,5,2.88c-.45.83-.88,1.67-1.31,2.52l-5.26-2.45-1.99,4.27,5.24,2.44c-.38.87-.74,1.74-1.09,2.62l-5.45-1.98-1.61,4.43,5.43,1.98c-.3.9-.6,1.79-.87,2.7l-5.59-1.5-1.22,4.55,5.58,1.5c-.22.92-.45,1.84-.64,2.77l-5.7-1-.82,4.64,5.68,1c-.14.93-.25,1.87-.36,2.82l-5.79-.51-.41,4.7,5.77.51c-.06.94-.1,1.89-.13,2.83h-5.82v4.71h5.8c.02.95.04,1.9.09,2.84l-5.78.51.41,4.7,5.76-.5c.1.94.22,1.88.36,2.82l-5.71,1.01.82,4.64,5.68-1c.19.93.4,1.85.62,2.77l-5.61,1.5,1.22,4.55,5.58-1.5c.27.91.55,1.81.84,2.71l-5.45,1.98,1.61,4.43,5.43-1.98c.34.88.69,1.76,1.06,2.63l-5.24,2.44,1.99,4.27,5.24-2.44c.42.85.85,1.69,1.29,2.53l-5.01,2.89,2.36,4.08,5-2.88c.49.81,1.01,1.6,1.53,2.39l-4.76,3.33,2.7,3.86,4.74-3.32c.56.76,1.14,1.51,1.73,2.25l-4.46,3.74,3.03,3.61,4.44-3.73c.62.71,1.26,1.41,1.91,2.1l-4.11,4.11,3.33,3.33,4.1-4.1c.68.65,1.37,1.3,2.08,1.93l-3.73,4.45,3.61,3.03,3.73-4.44c.74.59,1.47,1.19,2.23,1.75l-3.32,4.75,3.86,2.7,3.31-4.73c.79.52,1.58,1.03,2.39,1.53l-2.9,5.02,4.08,2.36,2.88-5c.83.45,1.67.88,2.52,1.31l-2.45,5.26,4.27,1.99,2.44-5.24c.87.38,1.74.74,2.62,1.09l-1.98,5.45,4.43,1.61,1.98-5.43c.9.3,1.79.6,2.7.87l-1.5,5.59,4.55,1.22,1.5-5.58c.92.22,1.84.45,2.77.64l-1,5.7,4.64.82,1-5.68c.93.14,1.87.25,2.82.36l-.51,5.79,4.7.41.51-5.77c.94.06,1.89.1,2.83.13v5.82h4.71v-5.81c.95-.02,1.9-.04,2.84-.09l.51,5.78,4.7-.41-.5-5.76c.94-.1,1.88-.22,2.82-.36l1.01,5.71,4.64-.82-1-5.68c.93-.19,1.85-.4,2.77-.62l1.5,5.61,4.55-1.22-1.5-5.58c.91-.27,1.81-.55,2.71-.84l1.98,5.45,4.43-1.61-1.98-5.43c.88-.34,1.76-.69,2.63-1.06l2.44,5.24,4.27-1.99-2.44-5.24c.85-.42,1.69-.85,2.53-1.29l2.89,5.01,4.08-2.36-2.88-5c.81-.49,1.6-1.01,2.39-1.53l3.33,4.76,3.86-2.7-3.32-4.74c.76-.56,1.51-1.14,2.25-1.73l3.74,4.46,3.61-3.03-3.73-4.44c.71-.62,1.41-1.26,2.1-1.91l4.11,4.11,3.33-3.33-4.1-4.1c.65-.68,1.3-1.37,1.93-2.08l4.45,3.73,3.03-3.61-4.44-3.73c.59-.74,1.19-1.47,1.75-2.23l4.75,3.32,2.7-3.86-4.73-3.31c.52-.79,1.03-1.59,1.53-2.39l5.02,2.9,2.36-4.08-5-2.88c.45-.83.88-1.67,1.31-2.52l5.26,2.45,1.99-4.27-5.23-2.44c.38-.87.74-1.74,1.09-2.62l5.45,1.98,1.61-4.43-5.43-1.98c.3-.9.6-1.79.87-2.7l5.59,1.5,1.22-4.55-5.58-1.5c.22-.92.45-1.84.64-2.77l5.7,1,.82-4.64-5.68-1c.14-.93.25-1.87.36-2.82l5.79.51.41-4.7-5.77-.51c.06-.94.1-1.89.13-2.83h5.82ZM1534.55,667.6c-26.01,0-47.09-21.08-47.09-47.09s21.08-47.09,47.09-47.09,47.09,21.08,47.09,47.09-21.09,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1534.55,538.14c-45.49,0-82.37,36.88-82.37,82.37s36.88,82.37,82.37,82.37,82.37-36.88,82.37-82.37-36.88-82.37-82.37-82.37ZM1534.55,667.6c-26.01,0-47.09-21.08-47.09-47.09s21.08-47.09,47.09-47.09,47.09,21.08,47.09,47.09-21.09,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M1534.55,563.02c-31.75,0-57.48,25.74-57.48,57.48s25.74,57.48,57.48,57.48,57.48-25.74,57.48-57.48-25.74-57.48-57.48-57.48ZM1534.55,670.39c-27.55,0-49.88-22.33-49.88-49.88s22.33-49.88,49.88-49.88,49.88,22.33,49.88,49.88-22.33,49.88-49.88,49.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-140",
    d: "M1534.55,568.42c-28.77,0-52.09,23.32-52.09,52.09s23.32,52.09,52.09,52.09,52.09-23.32,52.09-52.09-23.32-52.09-52.09-52.09ZM1534.55,668.6c-26.56,0-48.1-21.53-48.1-48.1s21.53-48.1,48.1-48.1,48.1,21.53,48.1,48.1-21.53,48.1-48.1,48.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M1534.52,570.02c-27.9,0-50.52,22.62-50.52,50.52s22.62,50.52,50.52,50.52,50.52-22.62,50.52-50.52-22.62-50.52-50.52-50.52ZM1501.75,587.95c4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08-4.01,4.01-8.97,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08ZM1493.71,630.94c-2.98,0-5.4-4.6-5.4-10.27s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27-2.42,10.27-5.4,10.27ZM1513.02,656.75c-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.97-3.45-11.08,2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09ZM1534.39,574.33c5.68,0,10.27,2.42,10.27,5.4s-4.6,5.4-10.27,5.4-10.27-2.42-10.27-5.4,4.6-5.4,10.27-5.4ZM1534.65,666.75c-5.67,0-10.27-2.42-10.27-5.4s4.6-5.4,10.27-5.4,10.27,2.42,10.27,5.4-4.6,5.4-10.27,5.4ZM1556.02,584.32c2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.97-3.45-11.08ZM1567.29,653.12c-4.01,4.01-8.98,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08,4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08ZM1575.33,630.68c-2.98,0-5.4-4.6-5.4-10.28s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27-2.42,10.28-5.4,10.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-166",
    d: "M1584.56,613.93c-3.24-24.77-24.38-43.92-50.04-43.92s-46.79,19.14-50.04,43.91c1.02,3.42,2.38,6.7,4.1,9.78-.16-.97-.27-1.98-.27-3.05,0-5.68,2.42-10.27,5.4-10.27s5.4,4.6,5.4,10.27-2.42,10.27-5.4,10.27c-.08,0-.15-.04-.22-.04,9.53,11.72,24.35,19.29,41.03,19.29s31.75-7.7,41.27-19.59c-.15.03-.3.09-.46.09-2.98,0-5.4-4.6-5.4-10.27s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27c0,1.21-.13,2.36-.33,3.44,1.75-3.12,3.13-6.44,4.16-9.91ZM1509.39,595.59c-4.01,4.01-8.98,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08,4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08ZM1534.39,585.13c-5.67,0-10.27-2.42-10.27-5.4s4.6-5.4,10.27-5.4,10.28,2.42,10.28,5.4-4.6,5.4-10.28,5.4ZM1570.55,598.85c-2.11,2.11-7.07.57-11.09-3.45-4.01-4.01-5.56-8.97-3.45-11.08,2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-151",
    d: "M1499.35,599.69c-.39-.15-.75-.36-1.04-.65-2.11-2.11-.57-7.07,3.45-11.08,4.01-4.01,8.98-5.56,11.08-3.45,1.71,1.71.99,5.29-1.47,8.72,7.16-2.89,14.98-4.49,23.18-4.49s15.9,1.58,23.02,4.43c-2.53-3.47-3.28-7.11-1.55-8.84,2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09-.29.3-.66.5-1.05.66,5.79,3.96,10.87,8.87,15.03,14.51,0-.03.02-.06.03-.08-3.24-24.77-24.38-43.92-50.04-43.92s-46.79,19.14-50.04,43.91c.01.05.04.09.05.14,4.1-5.58,9.11-10.45,14.81-14.39ZM1534.39,574.33c5.68,0,10.27,2.42,10.27,5.4s-4.6,5.4-10.27,5.4-10.27-2.42-10.27-5.4,4.6-5.4,10.27-5.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M1534.52,570.02c-27.9,0-50.52,22.62-50.52,50.52s22.62,50.52,50.52,50.52,50.52-22.62,50.52-50.52-22.62-50.52-50.52-50.52ZM1501.75,587.95c4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08-4.01,4.01-8.97,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08ZM1493.71,630.94c-2.98,0-5.4-4.6-5.4-10.27s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27-2.42,10.27-5.4,10.27ZM1513.02,656.75c-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.97-3.45-11.08,2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09ZM1534.39,574.33c5.68,0,10.27,2.42,10.27,5.4s-4.6,5.4-10.27,5.4-10.27-2.42-10.27-5.4,4.6-5.4,10.27-5.4ZM1534.65,666.75c-5.67,0-10.27-2.42-10.27-5.4s4.6-5.4,10.27-5.4,10.27,2.42,10.27,5.4-4.6,5.4-10.27,5.4ZM1556.02,584.32c2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.97-3.45-11.08ZM1567.29,653.12c-4.01,4.01-8.98,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08,4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08ZM1575.33,630.68c-2.98,0-5.4-4.6-5.4-10.28s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27-2.42,10.28-5.4,10.28Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-145",
    points: "1537.03 641.63 1532.86 641.63 1530.77 645.24 1532.86 648.85 1537.03 648.85 1539.11 645.24 1537.03 641.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M1536.99,645.24c0,1.13-.92,2.05-2.05,2.05s-2.05-.92-2.05-2.05.92-2.05,2.05-2.05,2.05.92,2.05,2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-145",
    points: "1551.24 633.69 1548.29 636.64 1549.37 640.67 1553.4 641.75 1556.35 638.8 1555.27 634.77 1551.24 633.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M1553.76,636.27c.8.8.8,2.09,0,2.89s-2.09.8-2.89,0c-.8-.8-.8-2.1,0-2.89s2.1-.8,2.89,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-145",
    points: "1555.67 618.03 1555.67 622.2 1559.29 624.29 1562.9 622.2 1562.9 618.03 1559.29 615.94 1555.67 618.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M1559.29,618.07c1.13,0,2.05.92,2.05,2.05s-.92,2.05-2.05,2.05-2.05-.92-2.05-2.05.92-2.05,2.05-2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-145",
    points: "1547.74 603.82 1550.69 606.77 1554.72 605.69 1555.8 601.66 1552.85 598.71 1548.82 599.79 1547.74 603.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M1550.32,601.29c.8-.8,2.1-.8,2.89,0,.8.8.8,2.1,0,2.89s-2.1.8-2.89,0c-.8-.8-.8-2.1,0-2.89Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-145",
    points: "1532.08 599.38 1536.25 599.38 1538.34 595.77 1536.25 592.16 1532.08 592.16 1529.99 595.77 1532.08 599.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M1532.12,595.77c0-1.13.92-2.05,2.05-2.05s2.05.92,2.05,2.05-.92,2.05-2.05,2.05-2.05-.92-2.05-2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-145",
    points: "1517.87 607.32 1520.82 604.37 1519.74 600.34 1515.71 599.26 1512.76 602.21 1513.84 606.24 1517.87 607.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M1515.34,604.74c-.8-.8-.8-2.1,0-2.89s2.1-.8,2.89,0c.8.8.8,2.1,0,2.89-.8.8-2.1.8-2.89,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-145",
    points: "1513.43 622.98 1513.43 618.81 1509.82 616.72 1506.21 618.81 1506.21 622.98 1509.82 625.07 1513.43 622.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M1509.82,622.94c-1.13,0-2.05-.92-2.05-2.05s.92-2.05,2.05-2.05,2.05.92,2.05,2.05-.92,2.05-2.05,2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-145",
    points: "1521.37 637.19 1518.42 634.24 1514.39 635.32 1513.31 639.35 1516.26 642.3 1520.29 641.22 1521.37 637.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M1518.79,639.72c-.8.8-2.09.8-2.89,0-.8-.8-.8-2.1,0-2.89s2.1-.8,2.89,0c.8.8.8,2.1,0,2.89Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-39",
    cx: 1534.55,
    cy: 620.5,
    r: 18.8,
    transform: "translate(10.7 1266.83) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M1547.74,620.5c0,7.28-5.9,13.18-13.18,13.18s-13.18-5.9-13.18-13.18,5.9-13.18,13.18-13.18,13.18,5.9,13.18,13.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-145",
    d: "M1678.72,682.15c-6.08-2.73-23.11-5.04-24.13-26.15-.48-9.85-.67-34.51-.81-46h-3.32v46.37c0,11.72,1.6,14.72,6.78,23.52,3.47,5.88,10.51,9.59,17.74,6.9l3.55-1.32c1.69-.63,1.82-2.59.19-3.32Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-48",
    cx: 1452.27,
    cy: 528.21,
    r: 6.88
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-48",
    cx: 1617.01,
    cy: 528.21,
    r: 6.88
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M1650.09,620.5h-11.99c0-57.04-46.41-103.45-103.45-103.45s-103.46,46.41-103.46,103.45h-11.99c0-63.66,51.79-115.44,115.45-115.44s115.45,51.79,115.45,115.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-142",
    d: "M1643.85,620.5h-4.8c0-57.57-46.84-104.41-104.41-104.41s-104.41,46.84-104.41,104.41h-4.8c0-60.22,48.99-109.21,109.21-109.21s109.21,48.99,109.21,109.21Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-48",
    cx: 1215.49,
    cy: 528.21,
    r: 6.88
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-48",
    cx: 1380.22,
    cy: 528.21,
    r: 6.88
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M1413.3,620.5h-11.99c0-57.04-46.41-103.45-103.45-103.45s-103.46,46.41-103.46,103.45h-11.99c0-63.66,51.79-115.44,115.45-115.44s115.45,51.79,115.45,115.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-142",
    d: "M1407.06,620.5h-4.8c0-57.57-46.84-104.41-104.41-104.41s-104.41,46.84-104.41,104.41h-4.8c0-60.22,48.99-109.21,109.21-109.21s109.21,48.99,109.21,109.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M367.61,213.83c-20.39-3-252.29,2.4-263.68,7.79-11.39,5.4-74.34,176.26-74.34,206.04,0,38.17-2.8,68.16,2.8,89.94h145.21l5.17-4.8c15.78-14.64,36.51-22.78,58.03-22.78h135.61c5.17,0,9.36-4.19,9.36-9.36v-10.81c0-3.81,3.05-7.14,6.86-7.01,2.3.08,4.19-1.76,4.19-4.04v-210.96c0-15.82-8.82-31.01-29.21-34.01ZM240.22,359.48c0,9.45-6.37,17.7-15.5,20.11l-127.56,33.59c-11.55,3.04-22.71-5.98-22.24-17.91,1.57-39.32,10.85-78.66,31.34-128.14,2.82-6.81,8.28-10.73,17.45-10.73h107.92c3.94,0,8.59,4.65,8.59,10.39v92.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-152",
    d: "M335.36,431.18c-124.03,0-234.59,18.08-306.44,46.31.03,2.13.08,4.2.15,6.24,71.85-28.19,182.35-46.25,306.3-46.25,11.04,0,50.65.15,61.46.43v-6.3c-10.81-.28-50.42-.43-61.46-.43Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-145",
    points: "166.74 517.6 35.08 517.6 35.08 590.44 67.95 590.44 67.95 629.52 75.74 629.52 75.74 590.44 117.71 590.44 117.71 629.52 125.51 629.52 125.51 590.44 137.16 590.44 166.74 517.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-146",
    points: "134.22 565.17 67.95 565.17 67.95 525 152.49 525 134.22 565.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M126.68,560.57h-46.45c-4.11,0-7.45-3.34-7.45-7.45v-28.12h74.86l-14.19,31.21c-1.21,2.66-3.86,4.37-6.78,4.37Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-145",
    x: 66,
    y: 622.94,
    width: 61.45,
    height: 6.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-147",
    x: 66,
    y: 619.65,
    width: 61.45,
    height: 6.58
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M63.55,629.52H29.38c-15.56,0-28.18-39.53-28.18-54.76v-38.48c0-8.95,7.49-16.28,16.64-16.28h45.72v109.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-144",
    d: "M63.55,629.52H29.38c-15.56,0-28.18-39.53-28.18-54.76v-38.48c0-8.95,7.49-16.28,16.64-16.28h45.72v109.52Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-42",
    x: 1800.26,
    y: 532.21,
    width: 13.19,
    height: 84.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-43",
    x: 1800.26,
    y: 488.77,
    width: 13.19,
    height: 90.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 1787.07,
    y: 528.21,
    width: 26.38,
    height: 50.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 277.7,
    y: 256.39,
    width: 78.69,
    height: 113.32,
    rx: 5.78,
    ry: 5.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-44",
    x: 280,
    y: 267.17,
    width: 74.08,
    height: 91.77,
    rx: 4.61,
    ry: 4.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-146",
    x: 431.65,
    width: 1424.13,
    height: 474.55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 438.55,
    y: 6,
    width: 1410.33,
    height: 462.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 438.55,
    y: 6,
    width: 1410.33,
    height: 462.56
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "442.88 8.79 1848.87 8.79 1848.87 6 438.55 6 438.55 468.56 442.88 468.56 442.88 8.79"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-142",
    x: 1109.43,
    y: 507.07,
    width: 4.7,
    height: 111.66,
    rx: 2.28,
    ry: 2.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-142",
    x: 799.99,
    y: 507.07,
    width: 4.7,
    height: 111.66,
    rx: 2.28,
    ry: 2.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-163",
    x: 747.95,
    y: 563.56,
    width: 418.22,
    height: 18.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-146",
    x: 747.95,
    y: 565.68,
    width: 418.22,
    height: 13.91
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-165",
    x: 747.95,
    y: 568.15,
    width: 418.22,
    height: 8.96
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-163",
    x: 747.95,
    y: 605.13,
    width: 418.22,
    height: 18.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-146",
    x: 747.95,
    y: 607.24,
    width: 418.22,
    height: 13.91
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-165",
    x: 747.95,
    y: 609.72,
    width: 418.22,
    height: 8.96
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-162",
    d: "M239.94,432.06h-22.7c-4.52,0-8.19-3.67-8.19-8.19h0c0-4.52,3.67-8.19,8.19-8.19h22.7c4.52,0,8.19,3.67,8.19,8.19h0c0,4.52-3.67,8.19-8.19,8.19Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-145",
    x: 213.75,
    y: 420.31,
    width: 28.17,
    height: 7.14
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M214.65,427.45h-7.62c-1.97,0-3.57-1.6-3.57-3.57h0c0-1.97,1.6-3.57,3.57-3.57h7.62v7.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M241.03,420.31h7.62c1.97,0,3.57,1.6,3.57,3.57h0c0,1.97-1.6,3.57-3.57,3.57h-7.62v-7.14Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 215.17,
    y: 421.31,
    width: 25.34,
    height: 5.14,
    rx: 1.11,
    ry: 1.11
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-145",
    d: "M381.8,531.84c0-25.52-20.69-46.21-46.21-46.21h-104.53c-30.03,0-57.31,17.48-69.85,44.76l-27.85,60.56h7.11c8.07,0,15.4-4.7,18.77-12.03l18.77-40.81c9.53-20.72,30.25-34,53.05-34h104.54c15.31,0,27.73,12.41,27.73,27.73v45.06c0,7.76,6.29,14.06,14.06,14.06h4.43v-59.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-145",
    d: "M367.39,523.4v108.78c0,15.1,1.6,18.96,6.78,30.3,3.47,7.57,10.51,12.35,17.74,8.88l3.55-1.7c1.69-.81,1.82-3.33.19-4.28-6.07-3.52-23.11-6.5-24.13-33.68-1.62-43.08.07-113.48-4.13-108.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-145",
    d: "M396.81,245.9H117.75c-8.54,0-16.2,5.07-19.52,12.93-10.67,25.25-35.48,90.47-35.48,150.45v108.32h2.4v-108.32c0-59.55,24.68-124.4,35.29-149.52,2.94-6.96,9.73-11.46,17.31-11.46h135.21c2.15.72,3.72,2.73,3.72,5.12v217.13c0,9.58-7.79,17.37-17.37,17.37h-5.71v1.8h5.71c10.57,0,19.17-8.6,19.17-19.17v-217.13c0-2-.82-3.81-2.14-5.12h140.47c.66,0,1.2-.54,1.2-1.2s-.54-1.2-1.2-1.2Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-145",
    x: 74.39,
    y: 499.36,
    width: 20.71,
    height: 12.88,
    rx: 1.64,
    ry: 1.64
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 75.52,
    y: 500.3,
    width: 18.45,
    height: 11,
    rx: 2.33,
    ry: 2.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-49",
    x: 91.09,
    y: 501.35,
    width: 2.17,
    height: 8.91,
    rx: 0.51,
    ry: 0.51
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 91.28,
    y: 501.52,
    width: 1.44,
    height: 2.53,
    rx: 0.34,
    ry: 0.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-49",
    x: 88.12,
    y: 501.35,
    width: 2.17,
    height: 8.91,
    rx: 0.51,
    ry: 0.51
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 88.31,
    y: 501.52,
    width: 1.44,
    height: 2.53,
    rx: 0.34,
    ry: 0.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-49",
    x: 85.15,
    y: 501.35,
    width: 2.17,
    height: 8.91,
    rx: 0.51,
    ry: 0.51
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 85.34,
    y: 501.52,
    width: 1.44,
    height: 2.53,
    rx: 0.34,
    ry: 0.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-49",
    x: 82.18,
    y: 501.35,
    width: 2.17,
    height: 8.91,
    rx: 0.51,
    ry: 0.51
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 82.37,
    y: 501.52,
    width: 1.44,
    height: 2.53,
    rx: 0.34,
    ry: 0.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-49",
    x: 79.21,
    y: 501.35,
    width: 2.17,
    height: 8.91,
    rx: 0.51,
    ry: 0.51
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 79.4,
    y: 501.52,
    width: 1.44,
    height: 2.53,
    rx: 0.34,
    ry: 0.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-49",
    x: 76.23,
    y: 501.35,
    width: 2.17,
    height: 8.91,
    rx: 0.51,
    ry: 0.51
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 76.43,
    y: 501.52,
    width: 1.44,
    height: 2.53,
    rx: 0.34,
    ry: 0.34
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-145",
    d: "M28.95,470.04h0c-.26,18.74.1,34.62,3.43,47.56h8.89v-35.24c0-6.8-5.52-12.32-12.32-12.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-141",
    d: "M42.47,482.36c0-7.45-6.06-13.52-13.52-13.52-.66,0-1.2.54-1.2,1.2s.54,1.2,1.2,1.2c6.13,0,11.12,4.99,11.12,11.12v35.24h2.4v-35.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-167",
    d: "M39.77,430.68c0-21.13,28.84-110.02,51.01-167.03,1.36-3.5-1.23-7.26-4.99-7.26h-.22c-22.55,52.9-55.99,149.56-55.99,171.26,0,2.71-.02,5.37-.04,8.01h5.3c2.72,0,4.94-2.2,4.94-4.93v-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-145",
    d: "M92.59,414.97c-4.24,0-8.36-1.43-11.78-4.18-4.74-3.81-7.33-9.49-7.08-15.57,1.61-40.29,11.3-79.94,31.43-128.55,3.15-7.61,9.4-11.47,18.56-11.47h107.92c4.53,0,9.79,5.06,9.79,11.59v92.69c0,9.98-6.74,18.73-16.39,21.27l-127.56,33.58c-1.62.43-3.26.64-4.88.64ZM123.71,257.59c-8.21,0-13.56,3.27-16.34,9.99-20.01,48.34-29.65,87.73-31.25,127.73-.21,5.32,2.04,10.28,6.19,13.61,4.13,3.31,9.43,4.44,14.55,3.09l127.56-33.58c8.6-2.26,14.61-10.06,14.61-18.95v-92.69c0-4.95-4.07-9.19-7.39-9.19h-107.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-145",
    d: "M34.83,436.86h-5.3c-.66,0-1.2-.54-1.2-1.2s.54-1.2,1.2-1.2h5.3c2.06,0,3.74-1.67,3.74-3.73,0-22.09,30.26-113.96,51.09-167.51.5-1.29.34-2.68-.44-3.82-.79-1.15-2.04-1.81-3.43-1.81-.66,0-1.31-.54-1.31-1.2s.42-1.2,1.09-1.2c2.39,0,4.41,1.07,5.63,2.85,1.22,1.78,1.48,4.04.69,6.05-23.55,60.54-50.92,146.5-50.92,166.59,0,3.43-2.75,6.18-6.14,6.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M16.73,389.67c-.4.12-.83.17-1.27.14-1.82-.12-3.08-1.54-2.83-3.19,2.09-13.66-6.85-24.06-6.94-24.16-1.09-1.25-.8-3.13.67-4.21,1.46-1.08,3.54-.94,4.64.31.44.49,10.68,12.3,8.21,28.48-.19,1.25-1.2,2.26-2.47,2.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-145",
    d: "M7.69,359.52c-.43-.49-1.03-.76-1.67-.9-1.12,1.1-1.32,2.71-.33,3.84.09.1,3.87,7.76,6.94,24.16.28,1.48.82,2.75,2.37,3.07.47-.46.8-1.05.9-1.7,2.47-16.18-7.77-27.99-8.21-28.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-145",
    d: "M128.21,249.6h-4.65c-.96,0-1.78.58-2.17,1.4H23.95c-13.21,0-23.95,10.75-23.95,23.95v96.79c0,9.82,5.89,18.54,15,22.21l65.88,26.56c.03,1.3,1.08,2.35,2.39,2.35h4.65c1.32,0,2.4-1.07,2.4-2.4s-1.07-2.4-2.4-2.4h-4.65c-.44,0-.82.15-1.18.35l-66.2-26.69c-5.23-2.11-9.27-6.08-11.51-10.97l7.92-3.19c.63-.25.94-.97.68-1.61-.25-.63-.97-.94-1.61-.68l-7.89,3.18c-.69-2.13-1.09-4.39-1.09-6.72v-62.87h12.78c.66,0,1.2-.54,1.2-1.2s-.54-1.2-1.2-1.2H2.4v-31.52c0-11.89,9.67-21.55,21.55-21.55h97.71c.44.59,1.1,1,1.9,1h4.65c1.32,0,2.4-1.07,2.4-2.4s-1.07-2.4-2.4-2.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-153",
    d: "M21.89,306.76c0,22.88-2.73,41.43-6.1,41.43s-6.1-18.55-6.1-41.43,2.73-41.43,6.1-41.43,6.1,18.55,6.1,41.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M16.55,264.22h.98v85.07h-.98c-4.61,0-8.34-3.74-8.34-8.34v-68.38c0-4.61,3.74-8.34,8.34-8.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-145",
    d: "M8.21,272.49h.1c1.8,0,3.25,1.46,3.25,3.25v62.02c0,1.8-1.46,3.25-3.25,3.25h-.1v-68.53h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-145",
    d: "M1120.63,488.77h46.17c1.99,0,3.6,1.61,3.6,3.6v18.44c0,1.99-1.61,3.6-3.6,3.6h-46.17c-1.99,0-3.6-1.61-3.6-3.6v-18.44c0-1.99,1.61-3.6,3.6-3.6Z",
    transform: "translate(2287.42 1003.18) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 1119.37,
    y: 491.48,
    width: 23.65,
    height: 20.22,
    rx: 3.58,
    ry: 3.58,
    transform: "translate(2262.39 1003.18) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-150",
    x: 1120.28,
    y: 493.41,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(2243.34 1003.18) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 1120.96,
    y: 493.73,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(2243.78 992.11) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-150",
    x: 1124.09,
    y: 493.41,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(2250.96 1003.18) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 1124.77,
    y: 493.73,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(2251.4 992.11) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-150",
    x: 1127.9,
    y: 493.41,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(2258.58 1003.18) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 1128.58,
    y: 493.73,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(2259.02 992.11) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-150",
    x: 1131.71,
    y: 493.41,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(2266.2 1003.18) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 1132.39,
    y: 493.73,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(2266.64 992.11) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-150",
    x: 1135.52,
    y: 493.41,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(2273.82 1003.18) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 1136.2,
    y: 493.73,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(2274.26 992.11) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-150",
    x: 1139.33,
    y: 493.41,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(2281.44 1003.18) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 1140.01,
    y: 493.73,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(2281.87 992.11) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 1144.4,
    y: 491.48,
    width: 23.65,
    height: 20.22,
    rx: 3.58,
    ry: 3.58,
    transform: "translate(2312.45 1003.18) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-49",
    x: 1145.31,
    y: 493.41,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(2293.4 1003.18) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1145.99,
    y: 493.73,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(2293.84 992.11) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-49",
    x: 1149.12,
    y: 493.41,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(2301.02 1003.18) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1149.8,
    y: 493.73,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(2301.46 992.11) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-49",
    x: 1152.93,
    y: 493.41,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(2308.64 1003.18) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1153.61,
    y: 493.73,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(2309.08 992.11) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-49",
    x: 1156.74,
    y: 493.41,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(2316.26 1003.18) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1157.42,
    y: 493.73,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(2316.7 992.11) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-49",
    x: 1160.55,
    y: 493.41,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(2323.88 1003.18) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1161.23,
    y: 493.73,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(2324.32 992.11) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-49",
    x: 1164.36,
    y: 493.41,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(2331.5 1003.18) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1165.04,
    y: 493.73,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(2331.93 992.11) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-145",
    d: "M498.15,488.77h46.17c1.99,0,3.6,1.61,3.6,3.6v18.44c0,1.99-1.61,3.6-3.6,3.6h-46.17c-1.99,0-3.6-1.61-3.6-3.6v-18.44c0-1.99,1.61-3.6,3.6-3.6Z",
    transform: "translate(1042.47 1003.18) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 496.89,
    y: 491.48,
    width: 23.65,
    height: 20.22,
    rx: 3.58,
    ry: 3.58,
    transform: "translate(1017.44 1003.18) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-150",
    x: 497.81,
    y: 493.41,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(998.39 1003.18) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 498.49,
    y: 493.73,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(998.82 992.11) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-150",
    x: 501.62,
    y: 493.41,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(1006.01 1003.18) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 502.3,
    y: 493.73,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(1006.44 992.11) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-150",
    x: 505.42,
    y: 493.41,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(1013.63 1003.18) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 506.11,
    y: 493.73,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(1014.06 992.11) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-150",
    x: 509.23,
    y: 493.41,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(1021.25 1003.18) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 509.92,
    y: 493.73,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(1021.68 992.11) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-150",
    x: 513.04,
    y: 493.41,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(1028.87 1003.18) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 513.72,
    y: 493.73,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(1029.3 992.11) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-150",
    x: 516.85,
    y: 493.41,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(1036.48 1003.18) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 517.53,
    y: 493.73,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(1036.92 992.11) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 521.92,
    y: 491.48,
    width: 23.65,
    height: 20.22,
    rx: 3.58,
    ry: 3.58,
    transform: "translate(1067.5 1003.18) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-49",
    x: 522.84,
    y: 493.41,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(1048.45 1003.18) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 523.52,
    y: 493.73,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(1048.89 992.11) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-49",
    x: 526.65,
    y: 493.41,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(1056.07 1003.18) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 527.33,
    y: 493.73,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(1056.5 992.11) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-49",
    x: 530.46,
    y: 493.41,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(1063.69 1003.18) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 531.14,
    y: 493.73,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(1064.12 992.11) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-49",
    x: 534.26,
    y: 493.41,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(1071.31 1003.18) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 534.95,
    y: 493.73,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(1071.74 992.11) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-49",
    x: 538.07,
    y: 493.41,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(1078.93 1003.18) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 538.76,
    y: 493.73,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(1079.36 992.11) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-49",
    x: 541.88,
    y: 493.41,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(1086.54 1003.18) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 542.56,
    y: 493.73,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(1086.98 992.11) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-145",
    d: "M1743.1,488.77h46.17c1.99,0,3.6,1.61,3.6,3.6v18.44c0,1.99-1.61,3.6-3.6,3.6h-46.17c-1.99,0-3.6-1.61-3.6-3.6v-18.44c0-1.99,1.61-3.6,3.6-3.6Z",
    transform: "translate(3532.38 1003.18) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 1741.85,
    y: 491.48,
    width: 23.65,
    height: 20.22,
    rx: 3.58,
    ry: 3.58,
    transform: "translate(3507.35 1003.18) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-150",
    x: 1742.76,
    y: 493.41,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(3488.3 1003.18) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 1743.44,
    y: 493.73,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(3488.73 992.11) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-150",
    x: 1746.57,
    y: 493.41,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(3495.92 1003.18) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 1747.25,
    y: 493.73,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(3496.35 992.11) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-150",
    x: 1750.38,
    y: 493.41,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(3503.54 1003.18) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 1751.06,
    y: 493.73,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(3503.97 992.11) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-150",
    x: 1754.19,
    y: 493.41,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(3511.15 1003.18) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 1754.87,
    y: 493.73,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(3511.59 992.11) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-150",
    x: 1758,
    y: 493.41,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(3518.77 1003.18) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 1758.68,
    y: 493.73,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(3519.21 992.11) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-150",
    x: 1761.81,
    y: 493.41,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(3526.39 1003.18) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 1762.49,
    y: 493.73,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(3526.83 992.11) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 1766.88,
    y: 491.48,
    width: 23.65,
    height: 20.22,
    rx: 3.58,
    ry: 3.58,
    transform: "translate(3557.41 1003.18) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-49",
    x: 1767.79,
    y: 493.41,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(3538.36 1003.18) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1768.47,
    y: 493.73,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(3538.79 992.11) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-49",
    x: 1771.6,
    y: 493.41,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(3545.98 1003.18) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1772.28,
    y: 493.73,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(3546.41 992.11) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-49",
    x: 1775.41,
    y: 493.41,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(3553.6 1003.18) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1776.09,
    y: 493.73,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(3554.03 992.11) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-49",
    x: 1779.22,
    y: 493.41,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(3561.22 1003.18) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1779.9,
    y: 493.73,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(3561.65 992.11) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-49",
    x: 1783.03,
    y: 493.41,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(3568.83 1003.18) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1783.71,
    y: 493.73,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(3569.27 992.11) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-49",
    x: 1786.84,
    y: 493.41,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(3576.45 1003.18) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1787.52,
    y: 493.73,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(3576.89 992.11) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-144",
    d: "M367.61,213.83c-20.39-3-252.29,2.4-263.68,7.79-11.39,5.4-74.34,176.26-74.34,206.04,0,38.17-2.8,68.16,2.8,89.94h145.21l5.17-4.8c15.78-14.64,36.51-22.78,58.03-22.78h135.61c5.17,0,9.36-4.19,9.36-9.36v-10.81c0-3.81,3.05-7.14,6.86-7.01,2.3.08,4.19-1.76,4.19-4.04v-210.96c0-15.82-8.82-31.01-29.21-34.01ZM240.22,359.48c0,9.45-6.37,17.7-15.5,20.11l-127.56,33.59c-11.55,3.04-22.71-5.98-22.24-17.91,1.57-39.32,10.85-78.66,31.34-128.14,2.82-6.81,8.28-10.73,17.45-10.73h107.92c3.94,0,8.59,4.65,8.59,10.39v92.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M386.51,529.59c0-26.49-21.47-47.96-47.96-47.96h-108.5c-31.17,0-59.48,18.14-72.5,46.46l-28.91,62.86h7.37c8.38,0,15.98-4.88,19.48-12.49l19.48-42.36c9.89-21.51,31.39-35.29,55.07-35.29h108.5c15.89,0,28.78,12.88,28.78,28.78v46.76c0,8.06,6.53,14.59,14.59,14.59h4.6v-61.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-146",
    d: "M160.31,197.53h219.58v24.37h-243.75v-.21c0-13.34,10.83-24.16,24.16-24.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-163",
    d: "M396.81,195.57V39.38s-216.57,125.18-239.8,148.15c-23.23,22.97-20.79,32.45-20.79,32.45l260.59-24.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-165",
    d: "M396.81,205.91v-72.11s-216.57,51.79-239.8,66.84c-23.23,15.04-20.79,21.26-20.79,21.26l260.59-15.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-144",
    d: "M157.01,187.54c-23.23,22.97-20.79,32.45-20.79,32.45h.01c-.02.27-.03.53-.04.8-.04.3-.05.53-.04.7,0,.07-.01.13-.01.2v.21h243.75v-14.96l16.92-1.04V39.38s-216.57,125.18-239.8,148.15Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg4AxSingleTandem);
export default __webpack_public_path__ + "static/media/4-Ax Single-Tandem.64e2f26aec6e74ffdaf6d5fb93f3762f.svg";
export { ForwardRef as ReactComponent };